/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/admin/user/message/template/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * 更新模板
         * @description 更新现有站内信模板
         */
        put: operations["updateTemplate"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * 更新任务
         * @description 更新站内信发送任务
         */
        put: operations["updateTask"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/{parentCode}/children/{childCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** 更新子字典 */
        put: operations["DictionaryChildUpdate"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/parents/{parentCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询父字典详情 */
        get: operations["DictionaryParentDetail"];
        /** 更新父字典 */
        put: operations["DictionaryParentUpdate"];
        post?: never;
        /** 删除父字典 */
        delete: operations["DictionaryParentDelete"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/waitlist/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 添加到等待名单 */
        post: operations["addToWaitlist"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/verification/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 验证验证码 */
        post: operations["verifyCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/verification/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送验证码 */
        post: operations["sendVerificationCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/verification/recaptcha": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["recaptcha"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/verification/recaptcha-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["recaptchaToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/twilio/verify/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["verifyCode_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/twilio/verify/test": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["sendVerificationCode1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/twilio/verify/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["sendVerificationCode_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/system/file/upload/avatar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传文件
         * @description 上传文件
         */
        post: operations["uploadAvatar"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/updateProfileInfo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改用户信息 */
        post: operations["updateUserInfo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/updatePreference": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改用户偏好设置 */
        post: operations["createUserSettingUpdatePreference"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/updatePassword": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改密码 */
        post: operations["updatePassword"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/updateContactInfo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改用户联系方式（需敏感操作令牌） */
        post: operations["createUserSettingUpdateContactInfo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/pwdValidCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 获取修改密码的验证码 */
        post: operations["pwdValidCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/contactValidCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 获取绑定联系方式的验证码（需敏感操作令牌） */
        post: operations["createUserSettingContactValidCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/contactCheck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 判断联系方式是否已经被绑定 */
        post: operations["contactCheck"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/checkPwdValidCode": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改密码前校验验证码 */
        post: operations["checkPwdValidCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/checkOldPwd": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 修改密码前校验旧密码 */
        post: operations["checkOldPwd"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/security/verify/issue-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 签发令牌：老设备需1次，新设备需2次 */
        post: operations["issueToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/security/verify/2fa": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 2FA校验一次并记录类型 */
        post: operations["verify2fa"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/security/anti-crawler/init": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 初始化接口防爬ServerSeed */
        post: operations["AntiCrawlerInit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/register/with-verification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 用户注册（带验证码验证） */
        post: operations["createUserRegisterWithVerification"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/password/reset": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 重置密码 */
        post: operations["resetPassword"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/password/forgot/verify-code": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 验证忘记密码验证码并生成重置令牌 */
        post: operations["verifyCodeAndGenerateToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/password/forgot/send-code": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送忘记密码验证码 */
        post: operations["createPasswordForgotSendCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/set-default": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 设置默认凭证 */
        post: operations["setDefault"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/rename": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 重命名凭证 */
        post: operations["rename"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/registration/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 完成Passkey注册，校验并入库 */
        post: operations["finishRegistration"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/registration/options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 开始Passkey注册 */
        post: operations["startRegistration"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/operation-auth/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 完成Passkey敏感操作认证，返回短期操作令牌 */
        post: operations["finishOperationAuth"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/operation-auth/options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 开始Passkey敏感操作认证（仅校验不过登录） */
        post: operations["startOperationAuth"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 删除凭证（物理删除） */
        post: operations["delete"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/authentication/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 完成Passkey认证，更新计数与直接登录（跳过2FA） */
        post: operations["finishAuthentication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/authentication/options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 开始Passkey认证 */
        post: operations["startAuthentication"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/my/followMatches/unfollow": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 取消关注 */
        post: operations["UserFollowMatchUnfollow"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/my/followMatches/follow": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 关注赛事 */
        post: operations["UserFollowMatchFollow"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/read": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 批量标记已读 */
        post: operations["markRead"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/readAll": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 全部标记已读 */
        post: operations["markAllRead"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 分页获取消息列表（支持ALL/UNREAD，支持分类筛选，返回包含内容） */
        post: operations["UserMessageList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 批量删除 */
        post: operations["delete_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 用户退出 */
        post: operations["logout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 登录 */
        post: operations["login"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/login/code/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 验证码登录 */
        post: operations["loginByCode"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/login/code/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送登录验证码 */
        post: operations["createLoginCodeSend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/login/check-exists": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 校验登录账号是否存在 */
        post: operations["UserLoginCheckExists"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/login/2fa/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 登录二次验证(2FA) */
        post: operations["login2faVerify"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/process/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 批量处理邀请码 */
        post: operations["processBatchInviteCodes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/internal/message/send-text": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送纯文本站内信 */
        post: operations["InternalMessageSendText"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/internal/message/send-by-template": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 基于模板发送站内信（立即） */
        post: operations["InternalMessageSendByTemplate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/internal/info/batch/base-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 批量获取用户基础信息 */
        post: operations["InternalUserBatchBaseInfo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/device/rename": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 设备改名 */
        post: operations["rename_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/banners/display": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 按分组和终端查询有效Banner
         * @description 查询指定分组、终端下，当前时间在有效期内的Banner，按sort升序返回
         */
        post: operations["display"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/banners/display-login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 登录后按分组和终端查询有效Banner
         * @description 查询指定分组、终端下，当前时间在有效期内的Banner，按sort升序返回
         */
        post: operations["createUserBannersDisplayLogin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/2fa/start-setup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 开始2FA设置，生成密钥与二维码URI */
        post: operations["startSetup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/2fa/disable": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 关闭2FA */
        post: operations["disable"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/2fa/confirm-setup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 确认绑定，输入一次TOTP开启2FA */
        post: operations["confirmSetup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/verification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送验证码邮件 */
        post: operations["sendVerificationCodeEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/verification/custom-sender": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送验证码邮件（指定发件人） */
        post: operations["sendVerificationCodeEmailWithCustomSender"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/template": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送自定义模板邮件 */
        post: operations["sendTemplateEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/template/custom-sender": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送自定义模板邮件（指定发件人） */
        post: operations["sendTemplateEmailWithCustomSender"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/invite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送邀请码邮件 */
        post: operations["sendInviteCodeEmail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/sendgrid/invite/custom-sender": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送邀请码邮件（指定发件人） */
        post: operations["sendInviteCodeEmailWithCustomSender"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/scene/template": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 根据业务场景发送模板邮件 */
        post: operations["sendTemplateEmail_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/scene/template/custom-sender": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 发送模板邮件（支持自定义发件人） */
        post: operations["sendTemplateEmailWithCustomSender_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/system/file/upload/avatar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传文件
         * @description 上传文件
         */
        post: operations["uploadAvatar_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 模板列表
         * @description 分页查询模板列表
         */
        post: operations["listTemplates"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 创建模板
         * @description 创建新的站内信模板
         */
        post: operations["createTemplate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/copy/{templateId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 复制模板（编码不变，语言固定为zh-CN，名称=原名-复制） */
        post: operations["AdminMessageTemplateCopy"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/send/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 发送任务(改变状态)
         * @description 将草稿/未启用任务切换为启用状态：IMMEDIATE设为SCHEDULED，ONCE入队，CRON注册Job
         */
        post: operations["sendTask"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/send-now/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 立即发送
         * @description 立即发送任务
         */
        post: operations["sendNow"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/recipients": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 任务收件人列表
         * @description 按任务ID分页查询收件人列表，可筛选阅读/删除状态
         */
        post: operations["listRecipients"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 任务列表
         * @description 分页查询任务列表
         */
        post: operations["listTasks"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 创建任务 */
        post: operations["AdminMessageTaskCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/copy/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 复制任务为草稿
         * @description 根据已有任务创建一个草稿任务（重置调度与计数）
         */
        post: operations["copyTask"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/cancel/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 取消任务
         * @description 取消已启动任务（置为CANCELLED），撤销调度/队列
         */
        post: operations["cancelTask"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/route/test-send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 测试发送Kafka路由消息 */
        post: operations["testSend"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/invite/batch-export": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 批量生成邀请码并导出Excel */
        post: operations["BatchGenerateAndExportInviteCodes"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/{parentCode}/children": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 新增子字典 */
        post: operations["DictionaryChildCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/parents": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询父字典列表 */
        get: operations["DictionaryParentList"];
        put?: never;
        /** 新建父字典 */
        post: operations["DictionaryParentCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/children/{childCode}/i18n": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询子字典多语言内容 */
        get: operations["DictionaryChildI18nDetail"];
        put?: never;
        /** 保存子字典多语言内容 */
        post: operations["DictionaryChildI18nSave"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/update-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 单独更新Banner状态
         * @description 通过BannerID更新状态（0-禁用，1-启用），不修改其他字段
         */
        post: operations["updateBannerStatus"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/save": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 新增/更新Banner
         * @description ID为空则新增，ID不为空则更新（支持文件上传）
         */
        post: operations["saveBanner"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 分页查询Banner
         * @description 多条件筛选（分组、位置、终端等），返回分页数据
         */
        post: operations["pageQuery"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/history/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 分页查询操作历史
         * @description 按Banner名称模糊查询，支持操作类型（create/update/delete等）筛选
         */
        post: operations["pageHistory"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/group/save": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 新增/更新分组
         * @description ID为空则新增，ID不为空则更新（名称不可重复）
         */
        post: operations["saveGroup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/group/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 分页查询分组
         * @description 支持按名称模糊搜索和状态过滤，返回分页数据
         */
        post: operations["pageQuery_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/group/batch-update-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 批量更新分组状态
         * @description 批量设置分组状态（0-禁用，1-启用）
         */
        post: operations["batchUpdateStatus"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/batch-update-sort": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 批量更新排序
         * @description 传入ID和排序值列表，批量调整Banner排序
         */
        post: operations["batchUpdateSort"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/{parentCode}/children/{childCode}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** 修改子字典状态 */
        patch: operations["DictionaryChildStatus"];
        trace?: never;
    };
    "/admin/user/dictionaries/parents/{parentCode}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** 修改父字典状态 */
        patch: operations["DictionaryParentStatus"];
        trace?: never;
    };
    "/api/user/system/cid/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取国家与VPC映射关系列表 */
        get: operations["list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/profileInfo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户基本信息方式 */
        get: operations["profileInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/getPreference": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户偏好设置 */
        get: operations["getUserSettingGetPreference"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/getPreference/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户偏好设置（内部接口） */
        get: operations["getPreference_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/disableWithdrawals/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户是否禁用提现（内部接口） */
        get: operations["disableWithdrawals"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/security/verify/check-token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 检查令牌是否有效 */
        get: operations["checkToken"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/security/device/is-old": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 判定是否老设备 */
        get: operations["isOld"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/public/invite/config/requirement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询邀请码验证开关状态 */
        get: operations["InviteRequirementSwitchPublic"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/wakeup/check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 按用户与设备检查可唤醒的Passkey
         * @description 根据userId与deviceId判断是否已在该设备下注册Passkey；若无，则返回可唤醒的认证器AAGUID及其名称与类别。支持的类别：platform_cloud/platform_local/password_manager/sdk_app/other。
         */
        get: operations["checkWakeup"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/passkey/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 凭证列表 */
        get: operations["list_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/my/followMatches/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 收藏列表 */
        get: operations["UserFollowMatchList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/unread/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 未读消息数 */
        get: operations["unreadCount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/message/unread/by-category": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 按分类统计未读消息数 */
        get: operations["unreadByCategory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/validate/{code}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 验证邀请码 */
        get: operations["validateInviteCode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/quota": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户邀请码生成配额信息 */
        get: operations["getGenerationQuota"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 生成邀请码 */
        get: operations["generateInviteCode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/health": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 生命周期续期 */
        get: operations["health"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/dictionary/config/{parentCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 根据字典编码获取配置（支持多语言，自动识别Header） */
        get: operations["GetUserDictionaryConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/device/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 设备列表（最近10条） */
        get: operations["list_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/basic": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户基础信息 */
        get: operations["getCurrentUser"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/area/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取全部区号 */
        get: operations["getAreaAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/area/ipIsIllegal": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 非法登入 */
        get: operations["ipIsIllegal"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/2fa/status/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询2FA状态 */
        get: operations["status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/scene/sender-config/{sceneCode}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取业务场景的发件人配置 */
        get: operations["getSenderConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/email/scene/scenes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取所有支持的业务场景 */
        get: operations["getAllScenes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/meta/modules": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取模板所属模块列表 */
        get: operations["modules"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/meta/languages": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取语言列表 */
        get: operations["languages"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/meta/categories": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取消息分类列表 */
        get: operations["categories"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/detail/{templateId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查看模板详情
         * @description 获取模板详细信息
         */
        get: operations["getTemplateDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/codes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取模板编码列表
         * @description 为任务编排提供全部可用模板编码
         */
        get: operations["AdminMessageTemplateCodes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/by-code/{code}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据code查询模板
         * @description 查询指定code的所有语言版本模板
         */
        get: operations["getTemplatesByCode"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/message/{recordId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 消息内容详情（按收件记录ID） */
        get: operations["AdminMessageContentByRecipientId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/detail/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查看任务详情
         * @description 获取任务详细信息
         */
        get: operations["getTaskDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dictionaries/children": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询子字典列表 */
        get: operations["DictionaryChildList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/verify/rate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 验证成功率 */
        get: operations["verifyRate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/trend/new-vs-churn": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 新增/流失趋势 */
        get: operations["newVsChurn"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/status/distribution": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 用户状态分布（玫瑰饼） */
        get: operations["statusDistribution"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/register/funnel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 注册转化漏斗 */
        get: operations["registerFunnel"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/invite/channel-stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 邀请码使用（渠道聚合） */
        get: operations["inviteChannelStats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/channel/quality-compare": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 渠道质量对比（D7留存% / 首充率%） */
        get: operations["channelQualityCompare"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/channel/effect": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 渠道效果（访问/注册/验证+转化率） */
        get: operations["channelEffect"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/cards": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 顶部指标卡片汇总（全量） */
        get: operations["cards"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/dashboard/active/heatmap": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 活跃热力（日期×小时） */
        get: operations["activeHeatmap"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询Banner详情
         * @description 根据ID查询Banner完整信息
         */
        get: operations["getBannerDetail"];
        put?: never;
        post?: never;
        /**
         * 删除Banner
         * @description 根据ID删除Banner
         */
        delete: operations["deleteBanner"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/valid": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询有效Banner
         * @description 按位置和终端查询启用且在时效范围内的Banner
         */
        get: operations["listValidBanners"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询分组Banner列表
         * @description 查询指定分组下的所有Banner，groupId为空时返回所有Banner
         */
        get: operations["bannerListAllWithGroup"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/history/latest/{bannerName}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询指定Banner最新操作记录
         * @description 获取指定Banner的最后一次操作记录（无记录返回空）
         */
        get: operations["getLatestHistory"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/group/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询分组详情
         * @description 根据ID查询分组完整信息
         */
        get: operations["getGroupDetail"];
        put?: never;
        post?: never;
        /**
         * 删除分组
         * @description 仅允许删除无关联Banner的分组
         */
        delete: operations["deleteGroup"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/banners/group/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询所有分组列表
         * @description 返回所有分组列表，可按状态过滤（0-禁用，1-启用）
         */
        get: operations["bannerGroupListAll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/template/delete/{templateId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * 删除模板
         * @description 删除站内信模板
         */
        delete: operations["deleteTemplate"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/admin/user/message/task/remove/{taskId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * 删除草稿任务
         * @description 仅草稿允许物理删除
         */
        delete: operations["removeDraftTask"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/intercom/group": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取当前用户绑定的客服群信息 */
        get: operations["getUserIntercomGroup"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/code/create": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 创建邀请码 */
        post: operations["createInviteCodeCreate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取邀请码汇总信息（已创建数/上限、邀请成功总人数） */
        get: operations["getUserInviteSummary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/default": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取默认邀请码 */
        get: operations["getUserInviteDefault"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/code/stats": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取邀请码统计信息 */
        get: operations["getInviteCodeStats"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/affiliate/rate-rules-config": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取返佣比率与规则配置 */
        get: operations["getUserAffiliateRateRulesConfig"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/typeX/getOpenTicket": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 获取个人是否有打开状态的工单（type：0游客，1用户） */
        post: operations["createUserTypeXGetOpenTicket"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/typeX/addTicket": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 用户创建工单（type：0游客，1用户） */
        post: operations["createUserTypeXAddTicket"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/typeX/activelyDisconnects": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** 用户主动关闭工单 */
        post: operations["createUserTypeXActivelyDisconnects"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/typeX/{type}/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取typex 用户token信息(type：0游客，1用户) */
        get: operations["getTypeX"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/invite/code/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 获取用户有效邀请码列表（未删除） */
        get: operations["getInviteCodeList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/setting/usernameChangeCooldown": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** 查询当前用户修改用户名（昵称）是否在冷却期及剩余秒数 */
        get: operations["getUserSettingUsernameChangeCooldown"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/users/update-preferred-currency": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 更新用户偏好货币
         * @description 更新当前登录用户的偏好领取币种
         */
        post: operations["createVipUsersUpdatePreferredCurrency"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/rewards/claim": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 用户领取奖励
         * @description 用户领取VIP奖励，支持单个奖励ID领取、按类型批量领取、指定币种金额领取。
         */
        post: operations["createVipRewardsClaim"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/users/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取当前用户VIP信息
         * @description 获取当前登录用户的VIP等级和经验值信息
         */
        get: operations["getVipUsersInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/rewards/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取当前用户奖励列表
         * @description 获取当前用户的VIP奖励记录列表，支持按状态筛选和限制数量。状态说明：0-初始化，1-进行中，2-可领取，3-发放中，4-已发放，5-已领取，6-发放/领取失败，7-已过期。不传status则返回所有状态的奖励记录。
         */
        get: operations["getVipRewardsList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/rewards/action-drop/days": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取Action Drop剩余天数
         * @description 获取用户当前Action Drop周期的剩余天数、提醒状态等信息
         */
        get: operations["getRewardsActionDropDays"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/levels/list": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取等级列表
         * @description 获取所有可用的VIP等级，可通过name或points筛选
         */
        get: operations["getVipLevelsList"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/home": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取当前用户的VIP首页聚合数据
         * @description 获取当前用户VIP等级、进度、权益、奖励、FAQ等聚合信息
         */
        get: operations["getUserVipHome"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/home/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 非登录用户获取VIP首页预览数据
         * @description 非登录用户获取默认VIP等级、进度、权益、奖励、FAQ等信息
         */
        get: operations["getVipHomePreview"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/vip/rewards/pending/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取当前用户待领取奖励数量
         * @description 统计当前用户可以领取但尚未领取的VIP奖励数量，即状态为3（可领取）且未过期的奖励记录数量。
         */
        get: operations["getRewardsPendingCount"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/saveLimit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** save limit */
        post: operations["createUserInsuranceSaveLimit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/addSelfExclusion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** add self-Exclusion */
        post: operations["createUserInsuranceAddSelfExclusion"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/removeLimit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** remove limit */
        get: operations["getUserInsuranceRemoveLimit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/lastResult": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get Last Result */
        get: operations["getUserInsuranceLastResult"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/getSelfExclusion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** getSelfExclusion */
        get: operations["getUserInsuranceGetSelfExclusion"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/getLimitAndSelfExclusion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Limit And SelfExclusion info */
        get: operations["getUserInsuranceGetLimitAndSelfExclusion"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/getLimitAndSelfExclusionById": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** internal interface get Limit And SelfExclusion ById */
        get: operations["getUserInsuranceGetLimitAndSelfExclusionById"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/getLimits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get limit */
        get: operations["getUserInsuranceGetLimits"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/saveQuestionResult": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** save question result */
        post: operations["createUserInsuranceSaveQuestionResult"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/insurance/getInsuranceStatus": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** getInsuranceStatus */
        get: operations["getUserInsuranceGetInsuranceStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/users/verification/captcha/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Verify captcha result
         * @description Verifies user captcha result by comparing provided X coordinate with stored value. Returns success status, score (0-10) and failure reason if not passed.
         */
        post: operations["createVerificationCaptchaVerify"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user/users/verification/captcha": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get image captcha
         * @description Generates a new image captcha with SVG background and puzzle piece. Returns base64 encoded images, Redis key for verification, and Y coordinate for positioning.
         */
        get: operations["getUsersVerificationCaptcha"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** @description 更新站内信模板请求 */
        MessageTemplateUpdateRequest: {
            /**
             * Format: int64
             * @description 模板ID
             * @example 1
             */
            id: number;
            /**
             * @description 模板名称
             * @example 新用户欢迎模板
             */
            name?: string;
            /**
             * @description 所属模块
             * @example USER
             * @enum {string}
             */
            module?: "USER" | "WALLET" | "BETTING" | "SYSTEM";
            /**
             * @description 消息分类
             * @example SYSTEM
             * @enum {string}
             */
            category?: "SYSTEM" | "PROMOTION" | "SECURITY" | "TRANSACTION";
            /**
             * @description 语言代码
             * @example zh-CN
             */
            language?: string;
            /**
             * @description 消息标题
             * @example 欢迎加入我们！
             */
            title?: string;
            /**
             * @description HTML内容（富文本）
             * @example <p>欢迎 ${username} 加入我们的平台！</p>
             */
            contentHtml?: string;
            /**
             * @description 纯文本内容
             * @example 欢迎 ${username} 加入我们的平台！
             */
            contentText?: string;
            /**
             * @description 封面图URL
             * @example https://example.com/cover.jpg
             */
            coverImage?: string;
            /**
             * @description 是否启用富文本
             * @example true
             */
            enableRichText?: boolean;
            /**
             * @description 是否配置按钮
             * @example false
             */
            buttonEnabled?: boolean;
            /**
             * @description 按钮名称
             * @example 立即前往
             */
            buttonText?: string;
            /**
             * @description 按钮跳转路径
             * @example /wallet/recharge
             */
            buttonUrl?: string;
        };
        SingleResponseLong: {
            success: boolean;
            errCode: string;
            errMessage: string;
            /** Format: int64 */
            data: number;
        };
        /** @description 更新站内信任务请求 */
        MessageTaskUpdateRequest: {
            /**
             * Format: int64
             * @description 任务ID
             * @example 1
             */
            taskId: number;
            /**
             * @description 模板编码
             * @example WELCOME_NEW_USER
             */
            templateCode?: string;
            /** @description 任务名称 */
            name?: string;
            /**
             * @description 受众类型
             * @example USER_IDS
             * @enum {string}
             */
            audienceType?: "USER_IDS" | "TAGS" | "ALL" | "USER_IDS" | "TAGS" | "ALL";
            /** @description 目标用户ID列表（当audienceType为USER_IDS时必填） */
            userIds?: number[];
            /** @description 目标用户标签列表（当audienceType为TAGS时必填） */
            tags?: string[];
            /**
             * Format: int64
             * @description 计划发送时间（毫秒，为空表示立即发送）
             * @example 1703123400000
             */
            scheduledTime?: number;
            /** @description 时区ID（IANA，例如 Asia/Shanghai） */
            timezone?: string;
            /**
             * Format: int32
             * @description 消息优先级
             * @example 1
             * @enum {integer}
             */
            priority?: 1 | 2 | 3;
            /**
             * @description 是否置顶
             * @example false
             */
            pinned?: boolean;
            /**
             * @description Cron表达式（当任务为CRON时可更新，必须分钟级：秒位为0）
             * @example 0 *\/5 * * * ?
             */
            cronExpression?: string;
            /**
             * Format: int32
             * @description 最大执行次数（CRON任务有效，0表示无限制）
             * @example 10
             */
            maxExecuteCount?: number;
        };
        SingleResponseObject: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        DictionaryChildUpdateRequest: {
            /** @description 子字典名称 */
            childName: string;
            /**
             * Format: int32
             * @description 排序值
             */
            sort?: number;
            /** @description 状态：ENABLED/DISABLED */
            status?: string;
            /** @description 子字典说明 */
            description?: string;
        };
        SingleResponseBoolean: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: boolean;
        };
        DictionaryParentUpdateRequest: {
            /** @description 父字典名称 */
            parentName: string;
            /** @description 状态：ENABLED/DISABLED */
            status?: string;
            /** @description 字典说明 */
            description?: string;
            /** @description 维护备注 */
            remark?: string;
        };
        WaitlistRequest: {
            email: string;
        };
        VerifyCodeRequest: {
            email?: string;
            phone?: string;
            code: string;
            type: string;
        };
        SendVerificationCodeRequest: {
            email?: string;
            phone?: string;
            type: string;
            /** 伪用户ID */
            pseudoId?: string;
        };
        ReCaptchaVerifierRequest: {
            "g-recaptcha-response": string;
        };
        SingleResponseString: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: string;
        };
        SendVerificationRequest: {
            phoneNumber: string;
        };
        /** 用户信息设置 */
        UpdateProfileInfoRequest: {
            /** @description 昵称 */
            userName: string;
            /** @description 头像url */
            avatar: string;
        };
        SingleResponseVoid: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: Record<string, never>;
        };
        /** 修改用户偏好设置请求 */
        UpdatePreferenceRequest: {
            /** @description 查看资产以XX法币为单位 */
            viewInFiat: string;
            /** @description 语言 */
            language: string;
            /** @description 显示加密货币全称 */
            showFullNameCrypto: boolean;
            /**
             * Format: int32
             * @description 显示模式
             */
            displayMode: number;
            /**
             * Format: int32
             * @description 市场模式 0: standard（默认）, 1: 3-way, 2: professional
             */
            marketMode: number;
            /** @description 开启充值邮箱通知 */
            depositEmailNotify: boolean;
            /** @description 开启提现邮箱通知 */
            withdrawEmailNotify: boolean;
            /** @description 是否接受营销邮件通知 */
            marketingEmailNotify: boolean;
            /** @description 用户主题 */
            userTheme: string;
            /** @description 用户区域设置 */
            userLocale: string;
        };
        /** 修改密码 */
        UpdatePasswordRequest: {
            /** @description 新密码[MD5(密码明文)] */
            newPassword: string;
            /** @description 设备ID */
            deviceId?: string;
            /** @description 敏感操作令牌 */
            token: string;
        };
        /** @description 联系方式更新 */
        UpdateContactInfoRequest: {
            /** @description 邮箱 */
            email?: string;
            /** @description 手机号 */
            phone?: string;
            /** @description 敏感操作令牌（修改联系方式时必填） */
            token?: string;
            /** @description 验证码 */
            code: string;
        };
        /** @description 获取验证码 */
        ContactCodeRequest: {
            /** @description 邮箱 */
            email: string;
            /** @description 手机号 */
            phone: string;
            /** @description 敏感操作令牌（修改联系方式时必填） */
            token: string;
        };
        /** @description 验证旧密码 */
        AuthenticateRequest: {
            /**
             * 时间戳
             * Format: int64
             */
            timestamp?: number;
            /** 加密串[HmacSHA256(MD5(密码明文),时间戳)] */
            digest: string;
        };
        /** 2FA确认绑定请求 */
        ConfirmSetupRequest: {
            /** @description 基于TOTP的6位数字验证码 */
            code: string;
        };
        AntiCrawlerInitResponse: {
            /**
             * ServerSeed
             * @description 接口防爬动态种子，用于后续请求签名与数据加密
             */
            serverSeed: string;
            /**
             * 有效期秒数
             * Format: int64
             * @description 当前ServerSeed预计有效的秒数，前端可用于预估刷新时机
             */
            expireSeconds: number;
        };
        SingleResponseAntiCrawlerInitResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["AntiCrawlerInitResponse"];
        };
        UserRegisterWithVerificationRequest: {
            password: string;
            confirmPassword: string;
            email?: string;
            phone?: string;
            emailCode?: string;
            smsCode?: string;
            registerType: string;
            inviteCode?: string;
            /** deviceId */
            deviceId?: string;
            /** 伪用户ID */
            pseudoId?: string;
            /** clientId */
            clientId?: string;
            /**
             * 平台
             * Format: int32
             */
            platform?: number;
            /**
             * 是否同意接收营销邮件
             * @description true=打开营销邮件偏好；false 或未传=关闭
             */
            acceptMarketingEmail?: boolean;
        };
        ResetPasswordRequest: {
            resetToken: string;
            newPassword: string;
            confirmPassword: string;
        };
        /** @description 忘记密码验证码验证请求 */
        VerifyForgotPasswordRequest: {
            /**
             * @description 验证目标（邮箱或手机号）
             * @example user@example.com
             */
            target: string;
            /**
             * @description 验证码
             * @example 123456
             */
            code: string;
            /**
             * @description 验证类型（email或sms）
             * @example email
             */
            type: string;
        };
        ForgotPasswordRequest: {
            email?: string;
            phone?: string;
            verificationType: string;
            recaptchaResponse?: string;
            captchaVersion?: string;
        };
        /** 通用Passkey ID请求 */
        PasskeyIdRequest: {
            /**
             * Format: int64
             * @description 凭证ID
             */
            id: number;
        };
        /** Passkey重命名请求 */
        PasskeyRenameRequest: {
            /**
             * Format: int64
             * @description 凭证ID
             */
            id: number;
            /** @description 凭证名称 */
            name: string;
        };
        /** @description 注册响应：包含attestationObject与clientDataJSON */
        PasskeyAttestationResponse: {
            /** @description attestationObject（base64url） */
            attestationObject: string;
            /** @description clientDataJSON（base64url） */
            clientDataJSON: string;
            /** @description transports（可选） */
            transports?: string[];
        };
        /** @description 完成注册入参（标准WebAuthn结构） */
        PasskeyRegistrationFinishRequest: {
            /** @description 凭证ID（base64url） */
            id: string;
            /** @description 原始ID（base64url） */
            rawId?: string;
            /**
             * @description 类型，固定public-key
             * @example public-key
             */
            type?: string;
            response?: components["schemas"]["PasskeyAttestationResponse"];
            /** @description 设备显示名称 */
            deviceName?: string;
            /** @description 平台标识（ios/android/windows/macos/chrome等） */
            platform?: string;
            /** @description 业务设备ID（同一设备唯一，限制每设备仅注册一个凭证） */
            deviceId?: string;
        };
        /** Passkey开始注册请求 */
        PasskeyStartRegistrationRequest: {
            /** @description 敏感操作令牌 */
            token: string;
        };
        /** @description 认证器选择策略 */
        PasskeyAuthenticatorSelection: {
            /**
             * @description 用户验证策略：required/preferred/discouraged
             * @example required
             */
            userVerification: string;
        };
        /** @description 公钥凭证描述符 */
        PasskeyDescriptor: {
            /**
             * @description 类型，固定为public-key
             * @example public-key
             */
            type: string;
            /** @description 凭证ID的base64url表示 */
            idB64u: string;
            /** @description 传输方式（usb,nfc,ble,internal） */
            transports: string[];
        };
        /** @description 公钥算法参数 */
        PasskeyPubKeyCredParam: {
            /**
             * @description 类型，固定为public-key
             * @example public-key
             */
            type: string;
            /**
             * Format: int32
             * @description COSE算法编号，-7=ES256，-257=RS256
             * @example -7
             */
            alg: number;
        };
        /** @description Passkey注册参数（PublicKeyCredentialCreationOptions裁剪） */
        PasskeyRegistrationOptions: {
            /**
             * @description 注册challenge（base64url）
             * @example Q2hhbGxlbmdlSWQ
             */
            challenge: string;
            rp: components["schemas"]["PasskeyRp"];
            user: components["schemas"]["PasskeyUser"];
            /** @description 支持的公钥算法列表（COSE alg） */
            pubKeyCredParams: components["schemas"]["PasskeyPubKeyCredParam"][];
            /**
             * Format: int64
             * @description 超时时间（毫秒）
             * @example 60000
             */
            timeout: number;
            /**
             * @description 声明政策：none/direct/indirect，默认none
             * @example none
             */
            attestation: string;
            /** @description 排除的已存在凭证（避免重复注册） */
            excludeCredentials: components["schemas"]["PasskeyDescriptor"][];
            authenticatorSelection: components["schemas"]["PasskeyAuthenticatorSelection"];
        };
        /** @description RP信息对象 */
        PasskeyRp: {
            /**
             * @description RP ID（域名）
             * @example dev.ccsccorp.com
             */
            id: string;
            /**
             * @description RP 展示名
             * @example BZ Dev
             */
            name: string;
        };
        /** @description WebAuthn用户身份对象 */
        PasskeyUser: {
            /** @description 用户ID的base64url表示（原始为字节） */
            idB64u: string;
            /** @description 用户标识（通常为账户名/邮箱/ID） */
            name: string;
            /** @description 展示名称（通常为昵称） */
            displayName: string;
        };
        SingleResponsePasskeyRegistrationOptions: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PasskeyRegistrationOptions"];
        };
        /** @description 认证响应：包含authenticatorData/clientDataJSON/signature/userHandle */
        PasskeyAssertionResponse: {
            /** @description authenticatorData（base64url） */
            authenticatorData: string;
            /** @description clientDataJSON（base64url） */
            clientDataJSON: string;
            /** @description signature（base64url） */
            signature: string;
            /** @description userHandle（base64url，可为空） */
            userHandle?: string;
        };
        /** @description 完成认证入参（标准WebAuthn结构） */
        PasskeyAuthenticationFinishRequest: {
            /** @description 凭证ID（base64url） */
            id: string;
            /** @description 原始ID（base64url） */
            rawId?: string;
            /**
             * @description 类型，固定public-key
             * @example public-key
             */
            type?: string;
            response?: components["schemas"]["PasskeyAssertionResponse"];
            /** @description 认证流程ID（未登录态使用，用于取回challenge） */
            authFlowId?: string;
            /**
             * @description 客户端标识（与登录保持一致）
             * @example web
             */
            clientId?: string;
            /** @description 设备标识（用于登录设备记录与缓存） */
            deviceId?: string;
            /** @description 轨迹id */
            pseudoId?: string;
        };
        /** @description Passkey认证参数（PublicKeyCredentialRequestOptions裁剪） */
        PasskeyAuthenticationOptions: {
            /**
             * @description 认证挑战（base64url）
             * @example QXV0aENoYWxsZW5nZUlE
             */
            challenge: string;
            rp: components["schemas"]["PasskeyRp"];
            /** @description 认证流程ID（未登录态用于从Redis取回challenge） */
            authFlowId: string;
            /** @description 允许使用的凭证列表（为空则由客户端发现） */
            allowCredentials: components["schemas"]["PasskeyDescriptor"][];
            /**
             * Format: int64
             * @description 超时时间（毫秒）
             * @example 60000
             */
            timeout: number;
            authenticatorSelection: components["schemas"]["PasskeyAuthenticatorSelection"];
        };
        SingleResponsePasskeyAuthenticationOptions: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PasskeyAuthenticationOptions"];
        };
        SingleResponseUserLoginResult: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserLoginResult"];
        };
        UserLoginResult: {
            user: {
                [key: string]: Record<string, never>;
            };
            deviceId: string;
            isFirstLoginToday: boolean;
            need2fa: boolean;
            ticket: string;
        };
        UserFollowMatchRequest: {
            /** 赛事id */
            matchId: string;
        };
        UserMessageListRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * @description 列表模式：ALL=全部，UNREAD=仅未读
             * @example ALL
             * @enum {string}
             */
            mode?: "ALL" | "UNREAD";
            /**
             * @description 消息分类：如 system, activity, marketing 等，可为空表示所有分类
             * @example system
             */
            category?: string;
        };
        SingleResponseUserPageResultUserMessage: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserPageResultUserMessage"];
        };
        /** @description 数据列表 */
        UserMessage: {
            /** Format: int64 */
            id: number;
            /** Format: int64 */
            taskId: number;
            category: string;
            language: string;
            title: string;
            contentHtml: string;
            contentText: string;
            coverImage: string;
            buttonEnabled: boolean;
            buttonText: string;
            buttonUrl: string;
            /** Format: int32 */
            priority: number;
            pinned: boolean;
            /** Format: int64 */
            createTime: number;
            read: boolean;
            /** Format: int64 */
            readTime: number;
        };
        /** @description 分页结果 */
        UserPageResultUserMessage: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["UserMessage"][];
        };
        LoginRequest: {
            /** @enum {string} */
            loginType: "email" | "sms" | "phone_quick" | "oauth" | "passkey" | "no_password";
            /** 账号 */
            registerId: string;
            /**
             * 时间戳
             * Format: int64
             */
            timestamp?: number;
            /** 加密串 */
            digest: string;
            /** deviceId */
            deviceId?: string;
            clientId?: string;
            pseudoId?: string;
        };
        LoginByCodeRequest: {
            /**
             * 验证类型
             * @description email-邮箱，sms-短信
             */
            type: string;
            /**
             * 邮箱地址
             * @description 当type=email时必填
             */
            email?: string;
            /**
             * 手机号
             * @description 当type=sms时必填，需为国际标准格式
             */
            phone?: string;
            /**
             * 验证码
             * @description 6位数字验证码
             */
            code: string;
            /**
             * deviceId
             * @description 设备ID
             */
            deviceId?: string;
            /**
             * clientId
             * @description 客户端ID
             */
            clientId?: string;
            /**
             * 伪ID
             * @description 伪用户ID
             */
            pseudoId?: string;
        };
        LoginCodeSendRequest: {
            /**
             * 验证类型
             * @description email-邮箱，sms-短信
             */
            type: string;
            /**
             * 邮箱地址
             * @description 当type=email时必填
             */
            email?: string;
            /**
             * 手机号
             * @description 当type=sms时必填，需为国际标准格式
             */
            phone?: string;
            /**
             * reCAPTCHA 校验 token
             * @description 单日第4～10次发送时必填
             */
            recaptchaResponse?: string;
            /**
             * reCAPTCHA 版本
             * @description 可选值：v2 或 v3；不传默认 v3
             */
            captchaVersion?: string;
        };
        UserExistCheckRequest: {
            /**
             * 验证类型
             * @description email-邮箱，sms-短信
             */
            type: string;
            /**
             * 邮箱地址
             * @description 当type=email时必填
             */
            email?: string;
            /**
             * 手机号
             * @description 当type=sms时必填，需为国际标准格式
             */
            phone?: string;
        };
        SingleResponseUserExistCheckResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserExistCheckResponse"];
        };
        UserExistCheckResponse: {
            /**
             * 是否存在
             * @description true-存在，false-不存在
             */
            exists: boolean;
            /**
             * 是否异常
             * @description true-异常（禁用/封控/锁定），false-正常
             */
            abnormal: boolean;
        };
        /** 登录2FA校验请求 */
        Login2faVerifyRequest: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description TOTP验证码 */
            code: string;
        };
        InternalTextMessageSendRequest: {
            title: string;
            content: string;
            category: string;
            /** Format: int32 */
            priority: number;
            pinned: boolean;
            userIds: number[];
        };
        InternalTemplateMessageSendRequest: {
            /** @description 模板编码（全局唯一） */
            templateCode: string;
            /** @description 语言（可选）。若为空，将按用户偏好语言发送，默认zh-CN */
            language: string;
            /** @description 是否置顶，默认false */
            pinned: boolean;
            /** @description 用户参数列表，每个用户独立的变量 */
            userParams: components["schemas"]["UserMessageParams"][];
        };
        /** @description 用户参数列表，每个用户独立的变量 */
        UserMessageParams: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 该用户的替换变量，如 {amount:100, userName:张三} */
            variables: {
                [key: string]: Record<string, never>;
            };
            /** @description 附带内容信息（可选），如订单详情,钱包充值提现动作等标识json */
            data: string;
        };
        UserBatchQueryRequest: {
            /** @description 用户ID列表 */
            userIds: number[];
        };
        SingleResponseListUserBaseInfoDTO: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserBaseInfoDTO"][];
        };
        UserBaseInfoDTO: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 用户昵称 */
            nickname: string;
            /** @description 真实姓名 */
            realName: string;
            /** @description 头像URL */
            avatar: string;
            /** @description 所属地区缩写 */
            countryCode: string;
            /**
             * Format: int64
             * @description 注册时间（毫秒级时间戳）
             */
            createTime: number;
        };
        UserDeviceRenameRequest: {
            /** @description 设备ID */
            deviceId: string;
            /** @description 新的设备名称 */
            deviceName: string;
        };
        /** @description 分组和终端查询参数 */
        BannerDisplayRequest: {
            /**
             * Format: int64
             * @description 所属分组ID（精确匹配）
             * @example 101
             */
            groupId: number;
            /**
             * @description 终端类型（精确匹配）
             * @example mobile
             * @enum {string}
             */
            terminal: "pc" | "mobile";
            /**
             * @description 语言标识（精确匹配，如zh-CN、en-US）
             * @example zh-CN
             * @enum {string}
             */
            language?: "zh-CN" | "en-US" | "ja-JP" | "ko-KR";
        };
        /** @description Banner信息响应（包含基本配置、资源信息及操作记录） */
        BannerResponse: {
            /**
             * Format: int64
             * @description Banner唯一标识ID
             * @example 1001
             */
            id: number;
            /**
             * @description Banner展示名称
             * @example 春节促销主Banner
             */
            name: string;
            /**
             * @description 分组名称（唯一）
             * @example 春节促销轮播组
             */
            groupName?: string;
            /**
             * @description Banner描述信息（可选）
             * @example 2024年春节期间首页顶部轮播图
             */
            description?: string | null;
            /**
             * Format: int64
             * @description 所属分组ID
             * @example 200
             */
            groupId: number;
            /**
             * @description 活动ID
             * @example campaign_123456
             */
            campaignId?: string;
            /**
             * @description 展示位置标识（页面中唯一）
             * @example home_top
             * @enum {string}
             */
            position: "home_top" | "product_side" | "category_banner";
            /**
             * @description 适用终端类型
             * @example mobile
             * @enum {string}
             */
            terminal: "pc" | "mobile" | "miniprogram";
            /**
             * @description 内容资源类型（STATIC-静态图片；VIDEO-视频；LOTTIE-Lottie动画）
             * @example STATIC
             * @enum {string}
             */
            type: "STATIC" | "VIDEO" | "LOTTIE";
            /**
             * @description 资源文件URL（根据type存储对应内容）
             * @example https://cdn.example.com/banner/spring_promo.jpg
             */
            resourceUrl: string;
            /**
             * @description 缩略图URL（用于后台列表预览）
             * @example https://cdn.example.com/banner/thumb/spring_promo_thumb.jpg
             */
            thumbUrl: string;
            /**
             * Format: int32
             * @description 是否新窗口打开链接（0-否，当前窗口打开；1-是，新窗口打开）
             * @example 0
             * @enum {integer}
             */
            isNewWindow: 0 | 1;
            /**
             * Format: int32
             * @description 展示优先级（数字越小越靠前）
             * @example 1
             */
            sort: number;
            /**
             * Format: int32
             * @description Banner启用状态（0-禁用，不展示；1-启用，符合时效条件时展示）
             * @example 1
             * @enum {integer}
             */
            status: 0 | 1;
            /**
             * @description 适用受众类型
             * @default ALL
             * @example ALL
             * @enum {string}
             */
            audienceType: "ALL" | "USER_IDS" | "TAGS";
            /**
             * @description 受众参数（与audienceType联动）
             *     1. USER_IDS：逗号分隔的用户ID，示例：123456,789012
             *     2. TAGS：逗号分隔的标签编码，示例：new_user,vip,high_consume
             *     3. ALL：该字段为空
             * @example 123456,789012
             */
            audienceValue?: string | null;
            /**
             * @description Banner所属国家/地区列表（标识可展示的国家范围）
             * @example ["CN","US","JP"]
             */
            countries?: string;
            /**
             * @description Banner语言选中列表（用户选中的语言标识）
             * @example ["zh-CN","en-US","ja-JP"]
             */
            languages?: string;
            /**
             * Format: int64
             * @description 生效开始时间（毫秒级时间戳，null表示立即生效）
             * @example 1703123400000
             */
            startTime?: number | null;
            /**
             * Format: int64
             * @description 生效结束时间（毫秒级时间戳，null表示永久生效）
             * @example 1705801800000
             */
            endTime?: number | null;
            /**
             * @description 时区
             * @example Asia/Shanghai
             */
            timeZone: string;
            /**
             * @description 创建人账号
             * @example admin
             */
            createdBy: string;
            /**
             * @description 最后更新人账号
             * @example editor
             */
            updatedBy: string;
            /**
             * Format: int64
             * @description 创建时间（毫秒级时间戳，服务器时间）
             * @example 1702518600000
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 最后更新时间（毫秒级时间戳，服务器时间）
             * @example 1702605000000
             */
            updatedAt: number;
            /**
             * @description Banner多语言配置列表（不同语言的标题/按钮文案等配置）
             * @example [
             *       {
             *         "id": 3001,
             *         "language": "zh-CN",
             *         "title": "2026春节特惠",
             *         "buttonText": "立即抢购",
             *         "alignType": "center",
             *         "tag": "促销,春节",
             *         "createdAt": 1702518600000,
             *         "updatedAt": 1702605000000
             *       },
             *       {
             *         "id": 3002,
             *         "language": "en-US",
             *         "title": "2026 Spring Sale",
             *         "buttonText": "Buy Now",
             *         "alignType": "center",
             *         "tag": "promotion,spring",
             *         "createdAt": 1702518600000,
             *         "updatedAt": 1702605000000
             *       }
             *     ]
             */
            configs: components["schemas"]["BannerConfigDTO"][];
        };
        SingleResponseListBannerResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["BannerResponse"][];
        };
        SingleResponseTwoFactorAuthSetupResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["TwoFactorAuthSetupResponse"];
        };
        TwoFactorAuthSetupResponse: {
            base32Secret: string;
            otpauthUri: string;
        };
        /** @description 模板查询请求 */
        MessageTemplateQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * @description 模块
             * @example WALLET
             */
            module?: string;
            /**
             * @description 分类
             * @example SYSTEM
             */
            category?: string;
            /**
             * @description 语言
             * @example zh-CN
             */
            language?: string;
            /**
             * @description 模板名称（模糊查询）
             * @example 欢迎
             */
            name?: string;
            /**
             * @description 模板代码（模糊查询）
             * @example WELCOME
             */
            code?: string;
        };
        /** @description 模板列表响应 */
        MessageTemplateListResponse: {
            /**
             * Format: int64
             * @description 模板ID
             * @example 1
             */
            id: number;
            /**
             * @description 模板代码
             * @example WELCOME_NEW_USER
             */
            code: string;
            /**
             * @description 模板名称
             * @example 新用户欢迎模板
             */
            name: string;
            /**
             * @description 所属模块
             * @example USER
             */
            module: string;
            /**
             * @description 消息分类
             * @example SYSTEM
             */
            category: string;
            /**
             * @description 语言
             * @example zh-CN
             */
            language: string;
            /**
             * Format: int64
             * @description 创建时间
             * @example 1703123400000
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间
             * @example 1703123400000
             */
            updateTime: number;
        };
        /** @description 分页结果 */
        PageResultMessageTemplateListResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["MessageTemplateListResponse"][];
        };
        SingleResponsePageResultMessageTemplateListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultMessageTemplateListResponse"];
        };
        /** @description 创建站内信模板请求 */
        MessageTemplateCreateRequest: {
            /**
             * @description 模板唯一编码
             * @example WELCOME_NEW_USER
             */
            code: string;
            /**
             * @description 模板名称
             * @example 新用户欢迎模板
             */
            name: string;
            /**
             * @description 所属模块
             * @example USER
             * @enum {string}
             */
            module: "USER" | "WALLET" | "BETTING" | "SYSTEM";
            /**
             * @description 消息分类
             * @example SYSTEM
             * @enum {string}
             */
            category: "SYSTEM" | "PROMOTION" | "SECURITY" | "TRANSACTION";
            /**
             * @description 语言代码
             * @example zh-CN
             */
            language: string;
            /**
             * @description 消息标题
             * @example 欢迎加入我们！
             */
            title: string;
            /**
             * @description HTML内容（富文本）
             * @example <p>欢迎 ${username} 加入我们的平台！</p>
             */
            contentHtml?: string;
            /**
             * @description 纯文本内容
             * @example 欢迎 ${username} 加入我们的平台！
             */
            contentText?: string;
            /**
             * @description 封面图URL
             * @example https://example.com/cover.jpg
             */
            coverImage?: string;
            /**
             * @description 是否启用富文本
             * @example true
             */
            enableRichText: boolean;
            /**
             * @description 是否配置按钮
             * @example false
             */
            buttonEnabled?: boolean;
            /**
             * @description 按钮名称
             * @example 立即前往
             */
            buttonText?: string;
            /**
             * @description 按钮跳转路径
             * @example /wallet/recharge
             */
            buttonUrl?: string;
        };
        /** @description 任务收件人查询请求 */
        MessageTaskRecipientQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 任务ID
             * @example 1
             */
            taskId: number;
            /**
             * Format: int32
             * @description 阅读状态：0未读 1已读
             */
            readStatus?: number;
            /**
             * Format: int32
             * @description 删除状态：0正常 1已删除
             */
            deleteStatus?: number;
            /**
             * @description 关键字（用户ID或昵称）
             * @example 10001/Alice
             */
            keyword?: string;
        };
        /** @description 任务收件人列表响应 */
        MessageTaskRecipientListResponse: {
            /**
             * Format: int64
             * @description 消息ID
             */
            messageId: number;
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 昵称 */
            nickname: string;
            /**
             * Format: int32
             * @description 阅读状态：0未读 1已读
             */
            readStatus: number;
            /**
             * Format: int64
             * @description 阅读时间（毫秒）
             */
            readTime: number;
            /**
             * Format: int32
             * @description 删除状态：0正常 1已删除
             */
            deleteStatus: number;
            /**
             * Format: int64
             * @description 记录ID
             */
            recordId: number;
        };
        /** @description 分页结果 */
        PageResultMessageTaskRecipientListResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["MessageTaskRecipientListResponse"][];
        };
        SingleResponsePageResultMessageTaskRecipientListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultMessageTaskRecipientListResponse"];
        };
        /** @description 任务分页查询请求 */
        MessageTaskQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /** @description 模板编码 */
            templateCode?: string;
            /**
             * @description 任务类型
             * @example IMMEDIATE
             * @enum {string}
             */
            taskType?: "IMMEDIATE" | "ONCE" | "CRON" | "IMMEDIATE" | "ONCE" | "CRON";
            /**
             * @description 受众类型
             * @example USER_IDS
             * @enum {string}
             */
            audienceType?: "USER_IDS" | "TAGS" | "ALL" | "USER_IDS" | "TAGS" | "ALL";
            /**
             * Format: int32
             * @description 任务状态
             * @example 1
             */
            status?: number;
            /** @description 操作人（更新操作人） */
            operator?: string;
        };
        /** @description 任务列表简化响应 */
        MessageTaskListResponse: {
            /**
             * Format: int64
             * @description 任务ID
             */
            id: number;
            /** @description 任务名称 */
            name: string;
            /** @description 模板编码 */
            templateCode: string;
            /** @description 任务类型代码 */
            taskType: string;
            /** @description 受众类型代码 */
            audienceType: string;
            /**
             * Format: int32
             * @description 状态
             */
            status: number;
            /**
             * Format: int64
             * @description 计划时间(ONCE)
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 下次执行时间(CRON)
             */
            nextExecuteTime: number;
            /**
             * Format: int32
             * @description 目标人数
             */
            totalTarget: number;
            /**
             * Format: int32
             * @description 已派发数
             */
            dispatchedCount: number;
            /**
             * Format: int32
             * @description 优先级
             */
            priority: number;
            /** @description 是否置顶 */
            pinned: boolean;
            /**
             * Format: int64
             * @description 创建时间（毫秒）
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒）
             */
            updateTime: number;
            /** @description 更新操作人 */
            updateBy: string;
        };
        /** @description 分页结果 */
        PageResultMessageTaskListResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["MessageTaskListResponse"][];
        };
        SingleResponsePageResultMessageTaskListResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultMessageTaskListResponse"];
        };
        /** @description 创建站内信任务请求 */
        MessageTaskCreateRequest: {
            /**
             * Format: int64
             * @description 任务ID
             * @example 1
             */
            taskId: number;
            /**
             * @description 模板编码
             * @example WELCOME_NEW_USER
             */
            templateCode: string;
            /**
             * @description 任务名称
             * @example 新用户充值通知第1批
             */
            name: string;
            /**
             * @description 受众类型
             * @example USER_IDS
             * @enum {string}
             */
            audienceType: "USER_IDS" | "TAGS" | "ALL" | "USER_IDS" | "TAGS" | "ALL";
            /** @description 目标用户ID列表（当audienceType为USER_IDS时必填） */
            userIds?: number[];
            /** @description 目标用户标签列表（当audienceType为TAGS时必填） */
            tags?: string[];
            /**
             * @description 任务类型
             * @example IMMEDIATE
             * @enum {string}
             */
            taskType: "IMMEDIATE" | "ONCE" | "CRON" | "IMMEDIATE" | "ONCE" | "CRON";
            /**
             * Format: int64
             * @description 计划发送时间（毫秒，当taskType为ONCE时必填）
             * @example 1703123400000
             */
            scheduledTime?: number;
            /**
             * @description 时区ID（IANA，例如 Asia/Shanghai）
             * @example Asia/Shanghai
             */
            timezone?: string;
            /**
             * @description Cron表达式（当taskType为CRON时必填）
             * @example 0 0 9 * * ?
             */
            cronExpression?: string;
            /**
             * Format: int32
             * @description 最大执行次数（当taskType为CRON时有效，0表示无限制）
             * @example 10
             */
            maxExecuteCount?: number;
            /**
             * Format: int32
             * @description 消息优先级
             * @example 1
             * @enum {integer}
             */
            priority?: 1 | 2 | 3;
            /**
             * @description 是否置顶
             * @example false
             */
            pinned?: boolean;
            /**
             * @description 任务提交动作：DRAFT=仅保存草稿，SEND=保存并发送
             * @example DRAFT
             * @enum {string}
             */
            submitAction?: "DRAFT" | "SEND" | "DRAFT" | "SEND";
        };
        /** @description Kafka路由发送测试请求 */
        NotificationRouteTestRequest: {
            /**
             * @description 收件人用户ID列表（字符串cid）
             * @example [
             *       "1001",
             *       "1002"
             *     ]
             */
            recipientUserIds: string[];
            /**
             * @description 消息内容（将转为二进制发送）
             * @example <b>Hello</b>
             */
            message: string;
        };
        /** @description 批量生成邀请码指令 */
        AdminBatchGenerateInviteCodeCmd: {
            /**
             * Format: int32
             * @description 生成数量
             * @example 100
             */
            quantity: number;
            /**
             * Format: date-time
             * @description 过期时间
             */
            expireTime: string;
            /**
             * @description 操作密钥
             * @example secret_123
             */
            secretKey: string;
        };
        DictionaryChildCreateRequest: {
            /** @description 子字典编码 */
            childCode: string;
            /** @description 子字典名称 */
            childName: string;
            /**
             * Format: int32
             * @description 排序值
             */
            sort?: number;
            /** @description 状态：ENABLED/DISABLED */
            status?: string;
            /** @description 子字典说明 */
            description?: string;
        };
        DictionaryParentCreateRequest: {
            /** @description 父字典编码 */
            parentCode: string;
            /** @description 父字典名称 */
            parentName: string;
            /** @description 字典类型：SYSTEM/NORMAL */
            dictType: string;
            /** @description 状态：ENABLED/DISABLED，默认ENABLED */
            status?: string;
            /** @description 字典说明 */
            description?: string;
            /** @description 维护备注 */
            remark?: string;
        };
        /** @description 语言内容列表 */
        DictionaryI18nSaveItem: {
            /** @description 语言编码 */
            languageCode: string;
            /** @description 展示内容，可为空 */
            content?: string;
        };
        DictionaryI18nSaveRequest: {
            /** @description 语言内容列表 */
            items: components["schemas"]["DictionaryI18nSaveItem"][];
        };
        /** @description Banner状态更新参数 */
        BannerStatusRequest: {
            /**
             * Format: int64
             * @description Banner唯一标识
             *      新增时无需传递，更新时必须传递
             * @example 10086
             */
            id: number;
            /**
             * Format: int32
             * @description Banner启用状态
             *     0-禁用，1-启用
             * @default 1
             * @example 1
             * @enum {integer}
             */
            status: 0 | 1;
        };
        /** @description Banner表单字段（使用 JSON 形式） */
        BannerUpdateRequest: {
            /**
             * Format: int64
             * @description Banner唯一标识
             *      新增时无需传递，更新时必须传递
             * @example 10086
             */
            id?: number;
            /**
             * @description Banner展示名称
             * @example 首页轮播-夏季促销
             */
            name: string;
            /**
             * Format: int64
             * @description Banner所属分组的ID
             * @example 101
             */
            groupId: number;
            /**
             * @description Banner展示的页面位置
             * @example home_top
             * @enum {string}
             */
            position: "home_top" | "product_side" | "category_banner";
            /**
             * @description Banner适用的终端类型
             * @example mobile
             * @enum {string}
             */
            terminal: "pc" | "mobile" | "miniprogram";
            /**
             * @description Banner的资源格式类型
             * @example STATIC
             * @enum {string}
             */
            type: "STATIC" | "VIDEO" | "LOTTIE";
            /**
             * @description 点击Banner后的跳转链接（可选）
             * @example https://www.example.com/promo
             */
            linkUrl?: string;
            /**
             * Format: int32
             * @description 展示优先级（数字越小越靠前）
             * @default 1
             * @example 1
             */
            sort: number;
            /**
             * @description 受众类型
             * @example 全部用户
             * @enum {string}
             */
            audienceType: "ALL" | "USER_IDS" | "TAGS";
            /**
             * Format: int32
             * @description Banner启用状态
             *     0-禁用，1-启用
             * @default 1
             * @example 1
             * @enum {integer}
             */
            status: 0 | 1;
            /**
             * @description Banner标签（用于快速筛选）
             * @example 促销,夏季
             */
            tag?: string;
            /**
             * Format: int64
             * @description Banner生效开始时间（时间戳，毫秒）
             *     为空时表示立即生效
             * @example 1717209600000
             */
            startTime?: number;
            /**
             * Format: int64
             * @description Banner生效结束时间（时间戳，毫秒）
             *     为空时表示立即生效
             * @example 1719801600000
             */
            endTime?: number;
            /**
             * @description 时区
             * @example Asia/Shanghai
             */
            timeZone: string;
            /** Format: binary */
            file?: string;
        };
        /** @description Banner分页查询参数（支持多条件组合筛选） */
        BannerQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 所属分组ID（精确匹配）
             * @example 101
             */
            groupId?: number;
            /**
             * @description Banner名称（模糊匹配，支持部分字符）
             * @example 夏季促销
             */
            name?: string;
            /**
             * @description 展示位置（精确匹配）
             * @example home_top
             * @enum {string}
             */
            position?: "home_top" | "product_side" | "category_banner";
            /**
             * @description 终端类型（精确匹配）
             * @example mobile
             * @enum {string}
             */
            terminal?: "pc" | "mobile" | "miniprogram";
            /**
             * @description 资源类型（精确匹配）
             * @example STATIC
             * @enum {string}
             */
            type?: "STATIC" | "VIDEO" | "LOTTIE";
            /**
             * Format: int32
             * @description 启用状态（精确匹配）0-禁用，1-启用（为空则不筛选）
             * @example 1
             * @enum {integer}
             */
            status?: 0 | 1;
            /**
             * @description 标签（模糊匹配，支持单个标签或标签片段）
             * @example 促销
             */
            tag?: string;
            /**
             * @description 受众类型
             * @example ALL
             * @enum {string}
             */
            audienceType?: "ALL" | "USER_IDS" | "TAGS";
        };
        /** @description 分页结果 */
        PageResultBannerResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["BannerResponse"][];
        };
        SingleResponsePageResultBannerResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultBannerResponse"];
        };
        /** @description Banner操作历史分页查询参数（查询指定Banner的操作记录） */
        BannerHistoryQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * @description Banner的名称
             * @example 春节促销
             */
            bannerName?: string;
            /**
             * @description 操作类型（精确匹配，可选）
             * @example update
             * @enum {string|null}
             */
            action?: "create" | "update" | "delete" | null;
            /**
             * @description 操作人账号
             * @example admin
             */
            operatedBy?: string;
            /**
             * Format: int64
             * @description 操作更新开始时间
             * @example 1717237800000
             */
            startTime?: number;
            /**
             * Format: int64
             * @description 操作更新结束时间
             * @example 1717237800000
             */
            endTime?: number;
        };
        /** @description Banner操作历史记录详情（包含操作类型、内容、执行人及时间等信息） */
        BannerHistoryResponse: {
            /**
             * Format: int64
             * @description 历史记录唯一ID
             * @example 5001
             */
            id: number;
            /**
             * Format: int64
             * @description 关联的BannerID
             * @example 10086
             */
            bannerId: number;
            /**
             * @description 关联的Banner名称
             * @example 春节大促销
             */
            bannerName: string;
            /**
             * @description 操作内容快照（JSON格式，存储操作前的旧数据）
             * @example {"name":"旧Banner名称","status":0}
             */
            before: string;
            /**
             * @description 操作内容快照（JSON格式，存储操作后的新数据）
             * @example {"name":"新Banner名称","status":0}
             */
            after: string;
            /**
             * @description 操作类型
             * @example update
             * @enum {string}
             */
            action: "create" | "update" | "delete";
            /**
             * @description 操作人账号
             * @example admin
             */
            operatedBy: string;
            /**
             * Format: int64
             * @description 操作时间（时间戳，毫秒级，对应UTC时间）
             * @example 1717237800000
             */
            operatedAt: number;
        };
        /** @description 分页结果 */
        PageResultBannerHistoryResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["BannerHistoryResponse"][];
        };
        SingleResponsePageResultBannerHistoryResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultBannerHistoryResponse"];
        };
        /** @description 分组信息（name和status为必填项） */
        BannerGroupUpdateRequest: {
            /**
             * Format: int64
             * @description 分组唯一标识
             *     新增时无需传递，更新时必须传递
             * @example 1001
             */
            id?: number | null;
            /**
             * @description 分组名称（唯一标识，不可重复）
             * @example 首页轮播分组
             */
            name: string;
            /**
             * Format: int32
             * @description 分组启用状态
             * @default 1
             * @example 1
             * @enum {integer}
             */
            status: 0 | 1;
            /**
             * @description 分组备注说明（可选）
             * @example 存放首页顶部轮播的Banner资源
             */
            remark?: string | null;
        };
        /** @description Banner分组分页查询参数（支持名称模糊匹配和状态筛选） */
        BannerGroupQueryRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * @description 分组名称（模糊匹配，支持部分字符）
             * @example 首页轮播组
             */
            name?: string | null;
            /**
             * Format: int32
             * @description 分组状态（精确匹配）
             *     0-禁用，1-启用，不传则查询全部状态
             * @example 1
             * @enum {integer|null}
             */
            status?: 0 | 1 | null;
        };
        /** @description Banner分组详情响应（包含分组基本信息及操作记录） */
        BannerGroupResponse: {
            /**
             * Format: int64
             * @description 分组唯一标识ID
             * @example 1001
             */
            id: number;
            /**
             * @description Banner名称（唯一）
             * @example 春节促销
             */
            name: string;
            /**
             * Format: int32
             * @description 分组启用状态
             * @example 1
             * @enum {integer}
             */
            status: 0 | 1;
            /**
             * @description 分组备注说明
             * @example 用于存放2024年春节期间的首页轮播Banner
             */
            remark: string | null;
            /**
             * @description 创建人账号
             * @example admin
             */
            createdBy: string;
            /**
             * @description 最后更新人账号
             * @example editor
             */
            updatedBy: string;
            /**
             * Format: int64
             * @description 创建时间（毫秒级时间戳，基于服务器时区）
             * @example 1704067200000
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 最后更新时间（毫秒级时间戳，基于服务器时区）
             * @example 1704157800000
             */
            updatedAt: number;
        };
        /** @description 分页结果 */
        PageResultBannerGroupResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["BannerGroupResponse"][];
        };
        SingleResponsePageResultBannerGroupResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultBannerGroupResponse"];
        };
        /** @description Banner排序调整参数（包含BannerID和目标排序值） */
        BannerSortRequest: {
            /**
             * Format: int64
             * @description Banner的唯一标识ID
             * @example 1001
             */
            id: number;
            /**
             * Format: int32
             * @description Banner的展示优先级（数字越小越靠前，0表示最低优先级）
             * @example 2
             */
            sort: number;
        };
        DictionaryChildStatusRequest: {
            /** @description 状态：ENABLED/DISABLED */
            status: string;
        };
        DictionaryParentStatusRequest: {
            /** @description 状态：ENABLED/DISABLED */
            status: string;
        };
        CountryVpcMappingConfigDto: {
            /** Format: int64 */
            id: number;
            cid: string;
            countryName: string;
            vid: string;
            vpcDomain: string;
        };
        MultiResponseCountryVpcMappingConfigDto: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["CountryVpcMappingConfigDto"][];
        };
        /** 用户基础信息 */
        ProfileInfoResponse: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 昵称 */
            userName: string;
            /** @description 头像 */
            avatar: string;
            /** @description 邮箱 */
            email: string;
            /** @description 邮箱是否已验证 */
            emailVerified: boolean;
            /** @description 手机号 */
            phone: string;
            /** @description 手机号是否已验证 */
            phoneVerified: boolean;
        };
        SingleResponseProfileInfoResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ProfileInfoResponse"];
        };
        /** 用户偏好设置 */
        PreferenceResponse: {
            /** @description 查看资产以XX法币为单位 */
            viewInFiat: string;
            /** @description 语言 */
            language: string;
            /** @description 显示加密货币全称 */
            showFullNameCrypto: boolean;
            /**
             * Format: int32
             * @description 显示模式
             */
            displayMode: number;
            /**
             * Format: int32
             * @description 市场模式 0: standard（默认）, 1: 3-way, 2: professional
             */
            marketMode: number;
            /** @description 开启充值邮箱通知 */
            depositEmailNotify: boolean;
            /** @description 开启提现邮箱通知 */
            withdrawEmailNotify: boolean;
            /** @description 是否接受营销邮件通知 */
            marketingEmailNotify: boolean;
            /** @description 用户主题 */
            userTheme: string;
            /** @description 用户地区（ISO 国家码） */
            userRegion: string;
            /** @description 用户区域设置 */
            userLocale: string;
        };
        SingleResponsePreferenceResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["PreferenceResponse"];
        };
        /** @description 邀请码验证开关返回对象 */
        InviteRequirementResponse: {
            /** @description 是否开启邀请码验证，true 表示注册需校验邀请码 */
            inviteCodeRequired: boolean;
        };
        SingleResponseInviteRequirementResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["InviteRequirementResponse"];
        };
        /** @description 按用户与设备检查可唤醒Passkey结果 */
        PasskeyWakeupCheckResult: {
            /**
             * @description 是否已在该设备下存在凭证
             * @example true
             */
            existsOnDevice: boolean;
            /** @description 若存在，返回凭证ID（base64url） */
            credentialIdB64u: string;
            /** @description 可唤醒的AAGUID标识（推荐使用AAGUID唤醒兼容前端策略） */
            aaguid: string;
            /** @description 认证器名称（基于AAGUID映射） */
            authenticatorName: string;
            /** @description 类别：platform_cloud/platform_local/browser_bound/password_manager/sdk_app/other */
            category: string;
        };
        SingleResponsePasskeyWakeupCheckResult: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PasskeyWakeupCheckResult"];
        };
        EventClockDto: {
            matchTime: string;
            stoppageTime: string;
            stoppageTimeAnnounced: string;
            remainingTime: string;
            remainingTimeInPeriod: string;
            stopped: boolean;
        };
        /** @description 从盘口服务获取的市场批量响应数据 */
        MarketBatchResponse: {
            marketList: components["schemas"]["MarketResponse"][];
            /** Format: int32 */
            totalMarkets: number;
        };
        /** 按玩法类型分组的赔率 */
        MarketResponse: {
            /**
             * 盘口ID
             * @description 盘口ID
             */
            marketId: string;
            /**
             * 玩法类型
             * @description 玩法类型
             */
            marketName: string;
            /** Format: int32 */
            marketTabType: number;
            /**
             * 盘口投注项赔率列表
             * @description 盘口投注项赔率列表
             */
            marketSpecifierList: components["schemas"]["MarketSpecifierDTO"][];
        };
        /**
         * 盘口投注项赔率列表
         * @description 盘口投注项赔率列表
         */
        MarketSpecifierDTO: {
            specifiers: string;
            /** Format: int32 */
            status: number;
            outcomes: components["schemas"]["OutcomeDTO"][];
        };
        MatchPeriodScoreDto: {
            /** Format: int32 */
            matchStatusCode: number;
            /** Format: int32 */
            number: number;
            homeScore: number;
            awayScore: number;
        };
        OutcomeDTO: {
            code: string;
            outcomeId: string;
            outcomeName: string;
            odds: number;
            /** Format: int32 */
            active: number;
            /** Format: int64 */
            updateTime: number;
            /** Format: int32 */
            phase: number;
        };
        /** @description 赛季比赛文档DTO，包含赛季信息和比赛详细数据 */
        SeasonMatchDocumentInnerDto: {
            /**
             * @description 赛季ID
             * @example sr:season:93931
             */
            seasonId: string;
            /**
             * @description 赛季名称
             * @example Premier League 22/23
             */
            seasonName: string;
            /**
             * @description 赛季年份
             * @example 22/23
             */
            seasonYear: string;
            /**
             * @description 比赛ID或URN
             * @example sr:match:37939735
             */
            id: string;
            /**
             * @description 体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 比赛名称
             * @example Arsenal vs Manchester United
             */
            name: string;
            /**
             * @description 主队ID
             * @example sr:competitor:42
             */
            homeId: string;
            /**
             * @description 主队名称
             * @example Arsenal
             */
            homeName: string;
            /**
             * @description 主队简称
             * @example ARS
             */
            homeShortName: string;
            /**
             * @description 主队Logo URL
             * @example https://example.com/arsenal_logo.png
             */
            homeLogoUrl: string;
            /** @description 主队球衣 */
            homeJersey: string;
            /**
             * @description 主队国家/地区代码
             * @example ENG
             */
            homeCountryCode: string;
            /**
             * @description 客队ID
             * @example sr:competitor:35
             */
            awayId: string;
            /**
             * @description 客队名称
             * @example Manchester United
             */
            awayName: string;
            /**
             * @description 客队简称
             * @example MU
             */
            awayShortName: string;
            /**
             * @description 客队Logo URL
             * @example https://example.com/mu_logo.png
             */
            awayLogoUrl: string;
            /** @description 客队球衣 */
            awayJersey: string;
            /**
             * @description 客队国家/地区代码
             * @example ENG
             */
            awayCountryCode: string;
            /**
             * @description 场馆ID
             * @example sr:venue:123
             */
            venueId: string;
            /**
             * @description 场馆名称
             * @example Emirates Stadium
             */
            venueName: string;
            /**
             * @description 裁判ID
             * @example sr:referee:456
             */
            refereeId: string;
            /**
             * @description 裁判名称
             * @example Anthony Taylor
             */
            refereeName: string;
            /**
             * @description 比赛类型
             * @example match
             */
            type: string;
            /**
             * @description 分组ID
             * @example sr:group:789
             */
            groupId: string;
            /**
             * @description 分组名称
             * @example Group A
             */
            groupName: string;
            /**
             * @description 阶段（例如：小组赛、淘汰赛）
             * @example Group Stage
             */
            phase: string;
            /**
             * @description 其他比赛ID
             * @example sr:match:99999
             */
            otherMatchId: string;
            /**
             * @description 联赛轮次
             * @example 21
             */
            tournamentRound: string;
            /**
             * Format: int64
             * @description 计划开始时间（Unix时间戳，毫秒）
             * @example 1674408600000
             */
            scheduledTime: number;
            /**
             * Format: int64
             * @description 计划结束时间（Unix时间戳，毫秒）
             * @example 1674415800000
             */
            scheduledEndTime: number;
            /**
             * Format: int32
             * @description 比赛状态
             */
            status: number;
            /** @description 比赛状态名称 */
            statusName: string;
            /**
             * Format: int32
             * @description 比赛状态
             */
            matchStatus: number;
            /** @description 比赛状态名称 */
            matchStatusName: string;
            sportEventStatus: components["schemas"]["SportEventStatusDto"];
            /**
             * @description 是否有雷达滚球赔率
             * @example true
             */
            hasRadarLiveOdds: boolean;
            /**
             * @description 是否有雷达赛前盘赔率
             * @example true
             */
            hasRadarPreMatchOdds: boolean;
            marketBatchResponse: components["schemas"]["MarketBatchResponse"];
            /** @description 直播流列表 */
            streamsList: components["schemas"]["StreamsDto"][];
        };
        SingleResponseListTournamentAggMatchHitDto: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["TournamentAggMatchHitDto"][];
        };
        SportEventStatusDto: {
            clock: components["schemas"]["EventClockDto"];
            periodScores: components["schemas"]["MatchPeriodScoreDto"][];
            /** Format: int32 */
            status: number;
            statusName: string;
            /** Format: int32 */
            matchStatus: number;
            matchStatusName: string;
            homeScore: number;
            awayScore: number;
            /** Format: int32 */
            homePenaltyScore: number;
            /** Format: int32 */
            awayPenaltyScore: number;
            /** Format: int32 */
            homeGamescore: number;
            /** Format: int32 */
            awayGamescore: number;
            /** Format: int32 */
            homeLegscore: number;
            /** Format: int32 */
            awayLegscore: number;
            /** Format: int32 */
            currentServer: number;
            expediteMode: boolean;
            tiebreak: boolean;
            /** Format: int32 */
            homeSuspend: number;
            /** Format: int32 */
            awaySuspend: number;
            /** Format: int32 */
            balls: number;
            /** Format: int32 */
            strikes: number;
            /** Format: int32 */
            outs: number;
            bases: string;
            /** Format: int32 */
            homeBatter: number;
            /** Format: int32 */
            awayBatter: number;
            pitcher: string;
            batter: string;
            /** Format: int32 */
            pitchCount: number;
            /** Format: int32 */
            pitchesSeen: number;
            /** Format: int32 */
            totalHits: number;
            /** Format: int32 */
            totalPitches: number;
            /** Format: int32 */
            possession: number;
            /** Format: int32 */
            position: number;
            /** Format: int32 */
            get_try: number;
            /** Format: int32 */
            yards: number;
            /** Format: int32 */
            get_throw: number;
            /** Format: int32 */
            visit: number;
            /** Format: int32 */
            remainingReds: number;
            /** Format: int32 */
            delivery: number;
            /** Format: int32 */
            homeRemainingBowls: number;
            /** Format: int32 */
            awayRemainingBowls: number;
            /** Format: int32 */
            currentEnd: number;
            /** Format: int32 */
            innings: number;
            /** Format: int32 */
            over: number;
            /** Format: int32 */
            homePenaltyRuns: number;
            /** Format: int32 */
            awayPenaltyRuns: number;
            /** Format: int32 */
            homeDismissals: number;
            /** Format: int32 */
            awayDismissals: number;
            /** Format: int32 */
            currentCtTeam: number;
            /** Format: int32 */
            periodOfLeader: number;
            /** Format: int32 */
            homeDriveCount: number;
            /** Format: int32 */
            awayDriveCount: number;
            /** Format: int32 */
            homePlayCount: number;
            /** Format: int32 */
            awayPlayCount: number;
            /** Format: int32 */
            cricketHomeOver: number;
            /** Format: int32 */
            cricketHomeDelivery: number;
            /** Format: int32 */
            cricketAwayOver: number;
            /** Format: int32 */
            cricketAwayDelivery: number;
        };
        /** @description 直播流DTO */
        StreamsDto: {
            /**
             * @description 直播流URL
             * @example https://example.com/live_stream.m3u8
             */
            streamUrl: string;
            /**
             * Format: int32
             * @description 直播流状态
             */
            streamStatus: number;
        };
        /** @description 按锦标赛分组的比赛聚合DTO，包含锦标赛、分类、运动及其关联的比赛列表 */
        TournamentAggMatchHitDto: {
            /**
             * @description 聚合ID
             * @example sr:tournament:12345
             */
            id: string;
            /**
             * @description 锦标赛的名称
             * @example Premier League
             */
            name: string;
            /**
             * @description 锦标赛的中文名称
             * @example 英超联赛
             */
            nameZh: string;
            /**
             * @description 锦标赛的简称
             * @example 英超
             */
            shortName: string;
            /**
             * @description 锦标赛的logo URL
             * @example https://example.com/tournament_logo.png
             */
            logoUrl: string;
            /**
             * Format: int32
             * @description 联赛等级, -1：未初始化
             * @example 1
             */
            level: number;
            /**
             * Format: int32
             * @description 性别：0男，1女，2未知
             * @example 0
             */
            gender: number;
            /**
             * @description 关联的锦标赛当前赛季ID
             * @example sr:season:93931
             */
            currentSeasonId: string;
            /**
             * Format: int32
             * @description 联赛类型：-1 未初始化, 0-未知、1-联赛、2-杯赛、3-友谊赛
             * @example 1
             */
            type: number;
            /**
             * Format: int32
             * @description 排序值
             * @example 10
             */
            sort: number;
            /**
             * @description 是否国家队比赛
             * @example true
             */
            isCountry: boolean;
            /**
             * @description 关联的项目类别ID
             * @example sr:category:29
             */
            categoryId: string;
            /**
             * @description 关联的项目类别名称
             * @example England
             */
            categoryName: string;
            /**
             * @description 关联的项目类别中文名称
             * @example 英格兰
             */
            categoryNameZh: string;
            /**
             * @description 关联的项目类别Logo URL
             * @example https://example.com/category_logo.png
             */
            categoryLogoUrl: string;
            /**
             * @description 关联的项目类别国家/地区代码
             * @example ENG
             */
            categoryCountryCode: string;
            /**
             * @description 关联的体育项目ID
             * @example sr:sport:1
             */
            sportId: string;
            /**
             * @description 体育项目名称
             * @example Football
             */
            sportName: string;
            /**
             * @description 体育项目中文名称
             * @example 足球
             */
            sportNameZh: string;
            /**
             * @description 体育项目Logo URL
             * @example https://example.com/sport_logo.png
             */
            sportLogoUrl: string;
            /**
             * Format: int64
             * @description 关联的比赛数量
             * @example 10
             */
            matchCount: number;
            /** @description 关联的比赛列表 */
            matches: components["schemas"]["SeasonMatchDocumentInnerDto"][];
        };
        SingleResponseInteger: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            /** Format: int32 */
            data: number;
        };
        SingleResponseListUnreadCountByCategoryResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UnreadCountByCategoryResponse"][];
        };
        UnreadCountByCategoryResponse: {
            /** @description 消息分类标识 */
            category: string;
            /**
             * Format: int32
             * @description 该分类下未读数量
             */
            count: number;
        };
        /** 邀请码生成配额信息 */
        InviteGenerationQuotaResponse: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /**
             * Format: int32
             * @description 当前未过期且未使用的邀请码数量
             */
            generatedCount: number;
            /**
             * Format: int32
             * @description 生成上限（配置值）
             */
            dailyLimit: number;
            /**
             * Format: int32
             * @description 可生成次数 = 上限 − 未过期未使用数量，最小为0
             */
            remainingQuota: number;
            /** @description 是否达到上限（remainingQuota <= 0） */
            isLimitReached: boolean;
            /** @description 邀请码 */
            inviteCode: string;
        };
        SingleResponseInviteGenerationQuotaResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["InviteGenerationQuotaResponse"];
        };
        /** @description 字典配置响应 */
        DictionaryConfigResponse: {
            /** @description 子字典编码 */
            code: string;
            /** @description 展示名称（已本地化） */
            name: string;
            /**
             * Format: int32
             * @description 排序值
             */
            sort: number;
        };
        SingleResponseListDictionaryConfigResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DictionaryConfigResponse"][];
        };
        MultiResponseUserDeviceVO: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserDeviceVO"][];
        };
        UserDeviceVO: {
            /**
             * Format: int64
             * @description 记录主键ID
             */
            id: number;
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 设备唯一ID */
            deviceId: string;
            /** @description 设备名称 */
            deviceName: string;
            /** @description 设备类型 */
            deviceType: string;
            /** @description 操作系统信息 */
            os: string;
            /** @description 最近登录IP */
            ip: string;
            /** @description 地区(根据IP解析得到的国家/地区代码) */
            region: string;
            /** @description 最近登录User-Agent */
            userAgent: string;
            /**
             * Format: date-time
             * @description 首次登录时间
             */
            firstLoginTime: string;
            /**
             * Format: date-time
             * @description 最近登录时间
             */
            lastLoginTime: string;
            /**
             * Format: int32
             * @description 累计登录次数
             */
            loginCount: number;
            /** @description 是否受信任 */
            trusted: boolean;
        };
        SingleResponseUserBasicResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserBasicResponse"];
        };
        /** 用户基础信息 */
        UserBasicResponse: {
            /**
             * Format: int64
             * @description 用户ID
             */
            userId: number;
            /** @description 用户名 */
            userName: string;
            /** @description 头像 */
            avatar: string;
            /** @description 邮箱 */
            email: string;
            /** @description 邮箱是否已验证 */
            emailVerified: boolean;
            /** @description 手机号 */
            phone: string;
            /** @description 手机号是否已验证 */
            phoneVerified: boolean;
            /** @description 2FA是否已验证 */
            twoFaVerified: boolean;
            /** @description Passkey是否已设置 */
            passkeySet: boolean;
            /** @description 是否新旧设备 */
            isOldDevice: boolean;
        };
        SingleResponseMapStringObject: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: {
                [key: string]: Record<string, never>;
            };
        };
        SingleResponseTwoFactorAuthEntity: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["TwoFactorAuthEntity"];
        };
        TwoFactorAuthEntity: {
            /** Format: int64 */
            userId: number;
            base32Secret: string;
            enabled: boolean;
            verified: boolean;
            /** Format: int64 */
            bindTime: number;
        };
        SingleResponseMapStringString: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: {
                [key: string]: string;
            };
        };
        SingleResponseListString: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: string[];
        };
        /** @description 站内信模板响应 */
        MessageTemplateResponse: {
            /**
             * Format: int64
             * @description 模板ID
             * @example 1
             */
            id: number;
            /**
             * @description 模板唯一编码
             * @example WELCOME_NEW_USER
             */
            code: string;
            /**
             * @description 模板名称
             * @example 新用户欢迎模板
             */
            name: string;
            /**
             * @description 所属模块
             * @example USER
             */
            module: string;
            /**
             * @description 消息分类
             * @example SYSTEM
             */
            category: string;
            /**
             * @description 语言代码
             * @example zh-CN
             */
            language: string;
            /**
             * @description 消息标题
             * @example 欢迎加入我们！
             */
            title: string;
            /**
             * @description HTML内容（富文本）
             * @example <p>欢迎 ${username} 加入我们的平台！</p>
             */
            contentHtml: string;
            /**
             * @description 纯文本内容
             * @example 欢迎 ${username} 加入我们的平台！
             */
            contentText: string;
            /**
             * @description 封面图URL
             * @example https://example.com/cover.jpg
             */
            coverImage: string;
            /**
             * @description 是否启用富文本
             * @example true
             */
            enableRichText: boolean;
            /**
             * @description 是否配置按钮
             * @example false
             */
            buttonEnabled: boolean;
            /**
             * @description 按钮名称
             * @example 立即前往
             */
            buttonText: string;
            /**
             * @description 按钮跳转路径
             * @example /wallet/recharge
             */
            buttonUrl: string;
            /**
             * @description 是否已删除
             * @example false
             */
            deleted: boolean;
            /**
             * Format: int64
             * @description 创建时间（毫秒）
             * @example 1703123400000
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒）
             * @example 1703123400000
             */
            updateTime: number;
            /**
             * @description 创建人
             * @example admin
             */
            createBy: string;
            /**
             * @description 更新人
             * @example admin
             */
            updateBy: string;
        };
        SingleResponseMessageTemplateResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["MessageTemplateResponse"];
        };
        /** @description 模板语言版本 */
        MessageTemplateLangVersion: {
            /**
             * Format: int64
             * @description 模板ID
             * @example 1
             */
            id: number;
            /**
             * @description 语言代码
             * @example zh-CN
             */
            language: string;
            /**
             * @description 消息标题
             * @example 欢迎加入我们！
             */
            title: string;
            /**
             * @description HTML内容（富文本）
             * @example <p>欢迎 ${username} 加入我们的平台！</p>
             */
            contentHtml: string;
            /**
             * @description 纯文本内容
             * @example 欢迎 ${username} 加入我们的平台！
             */
            contentText: string;
            /**
             * @description 封面图URL
             * @example https://example.com/cover.jpg
             */
            coverImage: string;
            /**
             * @description 是否配置按钮
             * @example false
             */
            buttonEnabled: boolean;
            /**
             * @description 按钮名称
             * @example 立即前往
             */
            buttonText: string;
            /**
             * @description 按钮跳转路径
             * @example /wallet/recharge
             */
            buttonUrl: string;
            /**
             * @description 是否已删除
             * @example false
             */
            deleted: boolean;
            /**
             * Format: int64
             * @description 创建时间（毫秒）
             * @example 1703123400000
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒）
             * @example 1703123400000
             */
            updateTime: number;
        };
        /** @description 多语言模板响应 */
        MessageTemplateMultiLangResponse: {
            /**
             * @description 模板编码
             * @example WELCOME_NEW_USER
             */
            code: string;
            /**
             * @description 模板名称
             * @example 新用户欢迎模板
             */
            name: string;
            /**
             * @description 所属模块
             * @example USER
             */
            module: string;
            /**
             * @description 消息分类
             * @example SYSTEM
             */
            category: string;
            /**
             * @description 是否启用富文本
             * @example true
             */
            enableRichText: boolean;
            /** @description 各语言版本模板列表 */
            versions: components["schemas"]["MessageTemplateLangVersion"][];
        };
        SingleResponseMessageTemplateMultiLangResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["MessageTemplateMultiLangResponse"];
        };
        /** @description 消息内容详情响应 */
        MessageContentResponse: {
            /**
             * Format: int64
             * @description 消息ID
             */
            id: number;
            /**
             * Format: int64
             * @description 任务ID
             */
            taskId: number;
            /** @description 分类 */
            category: string;
            /** @description 语言 */
            language: string;
            /** @description 标题 */
            title: string;
            /** @description 内容HTML */
            contentHtml: string;
            /** @description 内容Text */
            contentText: string;
            /** @description 封面图 */
            coverImage: string;
            /**
             * Format: int32
             * @description 优先级
             */
            priority: number;
            /** @description 是否置顶 */
            pinned: boolean;
            /**
             * Format: int64
             * @description 创建时间（毫秒）
             */
            createTime: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒）
             */
            updateTime: number;
            /**
             * Format: int32
             * @description 阅读状态：0未读 1已读
             */
            readStatus: number;
        };
        SingleResponseMessageContentResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["MessageContentResponse"];
        };
        MessageTask: {
            /** Format: int64 */
            id: number;
            name: string;
            templateCode: string;
            /** @enum {string} */
            audienceType: "USER_IDS" | "TAGS" | "ALL";
            audienceValue: string;
            /** @enum {string} */
            taskType: "IMMEDIATE" | "ONCE" | "CRON";
            /** Format: int64 */
            scheduledTime: number;
            cronExpression: string;
            /** Format: int64 */
            nextExecuteTime: number;
            timezone: string;
            /** Format: int32 */
            status: number;
            /** Format: int32 */
            totalTarget: number;
            /** Format: int32 */
            dispatchedCount: number;
            /** Format: int32 */
            maxExecuteCount: number;
            /** Format: int32 */
            executedCount: number;
            /** Format: int32 */
            priority: number;
            pinned: boolean;
            /** Format: int64 */
            createTime: number;
            /** Format: int64 */
            updateTime: number;
            updateBy: string;
            scheduled: boolean;
            cronTask: boolean;
            immediateTask: boolean;
            onceTask: boolean;
        };
        SingleResponseMessageTask: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["MessageTask"];
        };
        DictionaryParentListRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /** @description 编码或名称关键字，模糊匹配 */
            keyword?: string;
            /** @description 状态：ENABLED/DISABLED */
            status?: string;
            /** @description 字典类型：SYSTEM/NORMAL */
            dictType?: string;
        };
        /** @description 数据列表 */
        DictionaryParentResponse: {
            /** @description 父字典编码 */
            parentCode: string;
            /** @description 父字典名称 */
            parentName: string;
            /** @description 字典类型 */
            dictType: string;
            /** @description 状态 */
            status: string;
            /** @description 字典说明 */
            description: string;
            /** @description 维护备注 */
            remark: string;
        };
        /** @description 分页结果 */
        PageResultDictionaryParentResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["DictionaryParentResponse"][];
        };
        SingleResponsePageResultDictionaryParentResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultDictionaryParentResponse"];
        };
        SingleResponseDictionaryParentResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DictionaryParentResponse"];
        };
        DictionaryChildListRequest: {
            /**
             * Format: int32
             * @description 页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /** @description 父字典编码 */
            parentCode: string;
            /** @description 关键字（编码/名称），模糊匹配 */
            keyword?: string;
        };
        /** @description 数据列表 */
        DictionaryChildResponse: {
            /** @description 子字典编码 */
            childCode: string;
            /** @description 子字典名称 */
            childName: string;
            /** @description 子字典内容（默认语言） */
            defaultContent: string;
            /**
             * Format: int32
             * @description 排序值
             */
            sort: number;
            /** @description 状态 */
            status: string;
            /** @description 说明 */
            description: string;
            /** @description 最近更新时间 */
            updatedAt: string;
        };
        /** @description 分页结果 */
        PageResultDictionaryChildResponse: {
            /**
             * Format: int32
             * @description 当前页码
             * @example 1
             */
            pageNum: number;
            /**
             * Format: int32
             * @description 每页大小
             * @example 10
             */
            pageSize: number;
            /**
             * Format: int64
             * @description 总记录数
             * @example 100
             */
            total: number;
            /**
             * Format: int32
             * @description 总页数
             * @example 10
             */
            totalPages: number;
            /** @description 数据列表 */
            records: components["schemas"]["DictionaryChildResponse"][];
        };
        SingleResponsePageResultDictionaryChildResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["PageResultDictionaryChildResponse"];
        };
        /** @description 语言内容 */
        DictionaryI18nItemResponse: {
            /** @description 语言编码 */
            languageCode: string;
            /** @description 语言名称 */
            languageName: string;
            /** @description 展示内容 */
            content: string;
            /** @description 是否已维护 */
            maintained: boolean;
        };
        DictionaryI18nResponse: {
            /** @description 子字典编码 */
            childCode: string;
            /** @description 父字典编码 */
            parentCode: string;
            /** @description 语言内容 */
            items: components["schemas"]["DictionaryI18nItemResponse"][];
        };
        SingleResponseDictionaryI18nResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DictionaryI18nResponse"];
        };
        Item: {
            type: string;
            /** Format: double */
            rate: number;
        };
        SingleResponseVerifySuccessRateResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["VerifySuccessRateResponse"];
        };
        VerifySuccessRateResponse: {
            items: components["schemas"]["Item"][];
        };
        NewChurnTrendResponse: {
            newRegister: components["schemas"]["Point"][];
            churn: components["schemas"]["Point"][];
        };
        Point: {
            date: string;
            /** Format: int64 */
            value: number;
        };
        SingleResponseNewChurnTrendResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["NewChurnTrendResponse"];
        };
        SingleResponseStatusDistributionResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["StatusDistributionResponse"];
        };
        StatusDistributionResponse: {
            items: components["schemas"]["StatusDistributionResponseItem"][];
        };
        StatusDistributionResponseItem: {
            name: string;
            /** Format: int64 */
            value: number;
        };
        RegisterFunnelResponse: {
            stages: components["schemas"]["Stage"][];
        };
        SingleResponseRegisterFunnelResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["RegisterFunnelResponse"];
        };
        Stage: {
            stage: string;
            /** Format: int64 */
            value: number;
        };
        InviteChannelStatsItem: {
            /** @description 渠道名称 */
            channel: string;
            /**
             * Format: int64
             * @description 发放量
             */
            issued: number;
            /**
             * Format: int64
             * @description 使用量
             */
            used: number;
            /**
             * Format: double
             * @description 使用率(0-100)
             */
            useRate: number;
        };
        InviteChannelStatsResponse: {
            items: components["schemas"]["InviteChannelStatsItem"][];
        };
        SingleResponseInviteChannelStatsResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["InviteChannelStatsResponse"];
        };
        ChannelQualityCompareItem: {
            /** @description 渠道名称 */
            channel: string;
            /**
             * Format: double
             * @description D7留存率(0-100)
             */
            d7RetentionRate: number;
            /**
             * Format: double
             * @description 首充率(0-100)
             */
            firstDepositRate: number;
        };
        ChannelQualityCompareResponse: {
            items: components["schemas"]["ChannelQualityCompareItem"][];
        };
        SingleResponseChannelQualityCompareResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ChannelQualityCompareResponse"];
        };
        ChannelEffectItem: {
            /** @description 渠道名称 */
            channel: string;
            /**
             * Format: int64
             * @description 访问人数
             */
            visit: number;
            /**
             * Format: int64
             * @description 注册人数
             */
            register: number;
            /**
             * Format: int64
             * @description 验证人数
             */
            verify: number;
            /**
             * Format: double
             * @description 转化率(0-100)
             */
            conversionRate: number;
        };
        ChannelEffectResponse: {
            items: components["schemas"]["ChannelEffectItem"][];
        };
        SingleResponseChannelEffectResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ChannelEffectResponse"];
        };
        ConversionCard: {
            /** Format: int64 */
            visit: number;
            /** Format: int64 */
            register: number;
            /** Format: int64 */
            verify: number;
            /** Format: double */
            conversionRate: number;
        };
        DashboardCardsResponse: {
            scale: components["schemas"]["ScaleCard"];
            retention: components["schemas"]["RetentionCard"];
            conversion: components["schemas"]["ConversionCard"];
            invite: components["schemas"]["InviteUsageCard"];
        };
        InviteUsageCard: {
            /** Format: int64 */
            issued: number;
            /** Format: int64 */
            used: number;
            /** Format: double */
            useRate: number;
        };
        RetentionCard: {
            /** Format: double */
            d1: number;
            /** Format: double */
            d7: number;
            /** Format: double */
            d30: number;
        };
        ScaleCard: {
            /** Format: int64 */
            totalUsers: number;
            /** Format: int64 */
            dau: number;
            /** Format: int64 */
            mau: number;
            /** Format: int64 */
            lostYesterday: number;
        };
        SingleResponseDashboardCardsResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["DashboardCardsResponse"];
        };
        ActiveHeatmapResponse: {
            data: components["schemas"]["Cell"][];
            xhours: string[];
            ydays: string[];
        };
        Cell: {
            /** Format: int32 */
            x: number;
            /** Format: int32 */
            y: number;
            /** Format: int32 */
            value: number;
        };
        SingleResponseActiveHeatmapResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["ActiveHeatmapResponse"];
        };
        SingleResponseBannerResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["BannerResponse"];
        };
        SingleResponseBannerHistoryResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["BannerHistoryResponse"];
        };
        SingleResponseBannerGroupResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["BannerGroupResponse"];
        };
        SingleResponseListBannerGroupResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["BannerGroupResponse"][];
        };
        SingleResponseUserGroupResponse: {
            success: boolean;
            /** Format: int32 */
            errCode: number;
            errMessage: string;
            data: components["schemas"]["UserGroupResponse"];
        };
        UserGroupResponse: {
            /** @description 是否存在绑定的群 */
            hasGroup: boolean;
            /** @description 群链接（存在群时返回） */
            groupLink: string;
            /** @description Typex群ID（存在群时返回） */
            typexGroupId: string;
        };
        /**
         * @description Banner多语言配置信息
         * @example [
         *       {
         *         "id": 3001,
         *         "language": "zh-CN",
         *         "title": "2026春节特惠",
         *         "buttonText": "立即抢购",
         *         "alignType": "center",
         *         "tag": "促销,春节",
         *         "createdAt": 1702518600000,
         *         "updatedAt": 1702605000000
         *       },
         *       {
         *         "id": 3002,
         *         "language": "en-US",
         *         "title": "2026 Spring Sale",
         *         "buttonText": "Buy Now",
         *         "alignType": "center",
         *         "tag": "promotion,spring",
         *         "createdAt": 1702518600000,
         *         "updatedAt": 1702605000000
         *       }
         *     ]
         */
        BannerConfigDTO: {
            /**
             * Format: int64
             * @description 多语言配置唯一ID
             * @example 3001
             */
            id: number;
            /**
             * @description 语言标识（如zh-CN、en-US、ja-JP）
             * @example zh-CN
             * @enum {string}
             */
            language: "zh-CN" | "en-US" | "ja-JP" | "ko-KR";
            /**
             * @description 该语言下的Banner展示标题
             * @example 2026春节特惠·全场5折起
             */
            title?: string | null;
            /**
             * @description 该语言下的Banner标签
             * @example 促销
             */
            tag?: string;
            /**
             * @description 该语言下的按钮展示文本
             * @example 立即抢购
             */
            buttonText?: string | null;
            /**
             * @description 该语言下的内容对齐方式（left-左对齐，center-居中，right-右对齐）
             * @default center
             * @example center
             * @enum {string}
             */
            alignType: "left" | "center" | "right";
            /**
             * @description 点击跳转链接（内部路由或外部URL，可选）
             * @example https://www.example.com/spring-sale
             */
            linkUrl?: string | null;
        };
        /** 创建邀请码请求 */
        InviteCreateCodeRequest: {
            /** @description 邀请码名称（同一用户下唯一） */
            inviteName: string;
        };
        SingleResponseInviteCreateCodeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InviteCreateCodeResponse"];
        };
        /** 创建邀请码响应 */
        InviteCreateCodeResponse: {
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 邀请链接 */
            inviteLink: string;
            /** @description 佣金比例展示 */
            commissionRateDisplay: string;
        };
        SingleResponseInviteSummaryResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InviteSummaryResponse"];
        };
        /** @description 邀请码汇总信息 */
        InviteSummaryResponse: {
            /**
             * Format: int32
             * @description 已生效的代理个数（已创建的邀请码数量）
             */
            referralCodeCreatedUsed: number;
            /**
             * Format: int32
             * @description 总支持的代理个数上限
             */
            referralCodeCreatedTotal: number;
            /**
             * Format: int32
             * @description 邀请成功总人数（Friends）
             */
            friends: number;
        };
        SingleResponseInviteDefaultCodeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InviteDefaultCodeResponse"];
        };
        /** 默认邀请码响应 */
        InviteDefaultCodeResponse: {
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 邀请链接 */
            inviteLink: string;
        };
        SingleResponseListInviteCodeStatsResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InviteCodeStatsResponse"][];
        };
        /** 邀请码统计响应 */
        InviteCodeStatsResponse: {
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 邀请码名称 */
            inviteName: string;
            /** @description 该邀请码佣金比例 */
            commissionRate: number;
            /** @description 该邀请码阶梯奖励规则版本 */
            rewardRuleVersion: string;
            /** @description 该邀请码累计佣金奖励 */
            commissionRewards: number;
            /** @description 该邀请码累计推荐奖励 */
            referralRewards: number;
            /**
             * Format: int32
             * @description 该邀请码已绑定好友数
             */
            referrals: number;
            /**
             * Format: int64
             * @description 邀请码创建时间（毫秒级时间戳）
             */
            createTime: number;
        };
        SingleResponseReferralRateRulesConfigDTO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["ReferralRateRulesConfigDTO"];
        };
        /** @description 返佣比率与规则配置 */
        ReferralRateRulesConfigDTO: {
            /** @description 当前佣金比率 */
            currentCommissionRate: number;
            /** @description 固定奖励阶梯 */
            fixedRewardTiers: components["schemas"]["FixedRewardTierDTO"][];
            /** @description 固定奖励阶梯金额汇总（Referral Rewards 总金额） */
            referralRewardsTotal: number;
        };
        /** @description 固定奖励阶梯项 */
        FixedRewardTierDTO: {
            /** @description 有效投注阈值 */
            threshold: number;
            /** @description 固定奖励金额 */
            rewardAmount: number;
        };
        /** 检查工单 */
        TicketDTO: {
            /**
             * （type：0游客，1用户）
             * Format: int32
             */
            type: number;
            /** 账号ID */
            userId: string;
            /** 群ID */
            groupId: string;
            /** 设备信息 */
            deviceId?: string;
        };
        /** 添加工单 */
        TicketAddDTO: {
            /**
             * （type：0游客，1用户）
             * Format: int32
             */
            type: number;
            /** 账号ID */
            userId: string;
            /** 群ID */
            groupId: string;
            /** 设备信息 */
            deviceId?: string;
            /** type x 账号ID */
            typexAccount: string;
        };
        /** 关闭工单 */
        ActivelyDisconnectsDTO: {
            /**
             * （type：0游客，1用户）
             * Format: int32
             */
            type: number;
            /** 账号ID */
            userId: string;
            /** 群ID */
            groupId: string;
            /** 用户TypeXID */
            typeXId: string;
        };
        SingleResponseData: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["Data"];
        };
        Data: {
            /** 用户登陆token */
            token: string;
        };
        SingleResponseListInviteValidCodeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InviteValidCodeResponse"][];
        };
        /** 用户有效邀请码响应 */
        InviteValidCodeResponse: {
            /** @description 邀请码 */
            inviteCode: string;
            /** @description 邀请码名称 */
            inviteName: string;
            /** @description 邀请注册链接 */
            inviteLink: string;
            /** @description 该邀请码佣金比例（0.2500=25%） */
            commissionRate: number;
            /** @description 该邀请码阶梯奖励规则版本 */
            rewardRuleVersion: string;
            /**
             * Format: int64
             * @description 邀请码创建时间（毫秒级时间戳）
             */
            createTime: number;
        };
        SingleResponseUsernameChangeCooldownResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["UsernameChangeCooldownResponse"];
        };
        /** 用户名修改冷却状态 */
        UsernameChangeCooldownResponse: {
            /** @description 当前用户是否处于用户名修改冷却期（30天内已修改过昵称） */
            inCooldown: boolean;
            /**
             * Format: int64
             * @description 剩余冷却秒数；未在冷却期为0
             */
            remainingSeconds: number;
        };
        /** @description VIP用户更新请求 */
        VipUserUpdateRequest: {
            /**
             * @description 偏好领取币种
             * @example USDT
             * @enum {string}
             */
            preferredCurrency: "USDT" | "USD";
        };
        /** @description 用户领取VIP奖励请求 */
        VipRewardClaimRequest: {
            /**
             * @description 奖励类型
             * @example WEEKLY_EDGE
             */
            rewardType: string;
            /**
             * @description 奖励ID列表，批量领取时使用
             * @example [
             *       1001,
             *       1002,
             *       1003
             *     ]
             */
            rewardIds?: number[];
        };
        SingleResponseListVipRewardResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VipRewardResponse"][];
        };
        /** @description VIP奖励响应 */
        VipRewardResponse: {
            /**
             * Format: int64
             * @description 奖励ID
             * @example 1001
             */
            id: number;
            /**
             * Format: int64
             * @description 用户ID
             * @example 12345
             */
            userId: number;
            /**
             * @description 奖励类型
             * @example WEEKLY
             */
            rewardType: string;
            /**
             * @description 奖励金额
             * @example 100.5
             */
            amount: number;
            /**
             * Format: int32
             * @description 状态
             * @example 1
             */
            status: number;
            /**
             * @description 状态描述
             * @example 可领取
             */
            statusDesc: string;
            /**
             * @description 来源
             * @example weekly_task
             */
            source: string;
            /**
             * @description 业务ID
             * @example task_123
             */
            bizId: string;
            /**
             * @description 币种
             * @example USD
             */
            currency: string;
            /**
             * Format: int64
             * @description 过期时间戳
             * @example 1710940799000
             */
            expireTime: number;
            /**
             * @description 是否已过期
             * @example false
             */
            isExpired: boolean;
            /**
             * @description 是否可领取
             * @example true
             */
            isClaimable: boolean;
            /**
             * @description 备注
             * @example 周任务奖励
             */
            remark: string;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1710854399000
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 更新时间戳
             * @example 1710854399000
             */
            updatedAt: number;
        };
        SingleResponseVipUserResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VipUserResponse"];
        };
        /** @description VIP用户响应 */
        VipUserResponse: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 1643927984568913
             */
            userId: number;
            /**
             * Format: int32
             * @description VIP等级
             * @example 8
             */
            level: number;
            /**
             * @description VIP等级名称
             * @example Platinum V
             */
            levelName: string;
            /**
             * Format: int64
             * @description 当前经验值
             * @example 9000024
             */
            currentExp: number;
            /**
             * Format: int64
             * @description 总经验值
             * @example 9000024
             */
            totalExp: number;
            /**
             * @description 累计投注金额
             * @example 3000011.52
             */
            totalBetAmount: number;
            /**
             * Format: int64
             * @description 升级时间戳
             * @example 1774400383844
             */
            upgradeTime: number;
            /**
             * @description 偏好币种
             * @example USDT
             */
            preferredCurrency: string;
            /**
             * Format: int64
             * @description 最后投注时间戳
             * @example 1774400404514
             */
            lastBetTime: number;
            /**
             * Format: int32
             * @description 状态：1-启用，0-禁用
             * @example 1
             */
            status: number;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1774356479420
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 更新时间戳
             * @example 1774400404514
             */
            updatedAt: number;
        };
        SingleResponseVipActionDropDaysResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VipActionDropDaysResponse"];
        };
        /** @description Action Drop剩余天数响应 */
        VipActionDropDaysResponse: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 1001
             */
            userId: number;
            /**
             * Format: int32
             * @description 当前周期剩余天数
             * @example 5
             */
            remainingDays: number;
            /**
             * Format: int32
             * @description 总周期天数
             * @example 14
             */
            totalCycleDays: number;
            /**
             * @description 是否需要提醒（最后3天）
             * @example true
             */
            shouldRemind: boolean;
            /**
             * Format: int64
             * @description 周期开始时间戳
             * @example 1710854399000
             */
            cycleStartTime: number;
            /**
             * Format: int64
             * @description 周期结束时间戳
             * @example 1711948799000
             */
            cycleEndTime: number;
            /**
             * Format: int64
             * @description 下次重置时间戳
             * @example 1711948799000
             */
            nextResetTime: number;
        };
        SingleResponseListVipLevelResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VipLevelResponse"][];
        };
        /** @description VIP等级响应 */
        VipLevelResponse: {
            /**
             * Format: int64
             * @description 等级ID
             * @example 1
             */
            id: number;
            /**
             * Format: int32
             * @description 等级（1-10）
             * @example 3
             */
            level: number;
            /**
             * @description 等级名称
             * @example Gold
             */
            name: string;
            /**
             * Format: int64
             * @description 最低经验值（包含）
             * @example 1000
             */
            minExp: number;
            /**
             * Format: int64
             * @description 最高经验值（包含）
             * @example 4999
             */
            maxExp: number;
            /**
             * @description 晋升奖励金额
             * @example 100
             */
            upgradeBonus: number;
            /**
             * @description 等级图标URL
             * @example https://example.com/icons/gold.png
             */
            icon: string;
            /**
             * @description 背景图URL
             * @example https://example.com/backgrounds/gold.jpg
             */
            background: string;
            /**
             * Format: int32
             * @description 状态
             * @example 1
             */
            status: number;
            /**
             * @description 状态描述
             * @example 启用
             */
            statusDesc: string;
            /**
             * @description 是否激活
             * @example true
             */
            isActive: boolean;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1710854399000
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 更新时间戳
             * @example 1710854399000
             */
            updatedAt: number;
            /**
             * @description 升级到该等级累计投注金额
             * @example 5000
             */
            upgradeCost: number;
        };
        SingleResponseVipHomeResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VipHomeResponse"];
        };
        VipHomeResponse: {
            level: components["schemas"]["VipLevelResponse"];
            progress: components["schemas"]["VipProgressResponse"];
            benefits: components["schemas"]["VipBenefitResponse"][];
            rewards: components["schemas"]["VipRewardResponse"][];
            faq: {
                [key: string]: components["schemas"]["VipFaqResponse"][];
            };
        };
        /** @description VIP进度响应 */
        VipProgressResponse: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 1001
             */
            userId: number;
            /**
             * @description 偏好币种
             * @example USDT
             */
            preferredCurrency: string;
            /**
             * Format: int32
             * @description 当前VIP等级
             * @example 3
             */
            currentLevel: number;
            /**
             * @description 当前等级名称
             * @example GOLD
             */
            currentLevelName: string;
            /**
             * Format: int64
             * @description 当前等级最小经验值
             * @example 5000
             */
            currentLevelMinPoints: number;
            /**
             * Format: int64
             * @description 当前等级最大经验值
             * @example 10000
             */
            currentLevelMaxPoints: number;
            /**
             * Format: int32
             * @description 下一VIP等级
             * @example 4
             */
            nextLevel: number;
            /**
             * @description 下一等级名称
             * @example PLATINUM
             */
            nextLevelName: string;
            /**
             * @description 是否已达到最高等级
             * @example false
             */
            isMaxLevel: boolean;
            /**
             * Format: int64
             * @description 当前经验值（累计）
             * @example 7500
             */
            currentPoints: number;
            /**
             * Format: int64
             * @description 升级所需经验值（剩余差值）
             * @example 2500
             */
            gapToNextLevel: number;
            /**
             * Format: int64
             * @description 升级所需总经验值（目标等级门槛）
             * @example 10000
             */
            requiredPoints: number;
            /**
             * @description 升级进度百分比（0~100）
             * @example 75.5
             */
            progressPercentage: number;
            /**
             * @description Action Drop状态
             * @example AVAILABLE
             */
            actionDropStatus: string;
            /**
             * @description 是否有Action Drop奖励
             * @example true
             */
            hasActionDropReward: boolean;
            /**
             * @description Weekly Edge状态
             * @example AVAILABLE
             */
            weeklyEdgeStatus: string;
            /**
             * @description 是否有Weekly Edge奖励
             * @example true
             */
            hasWeeklyEdgeReward: boolean;
            /**
             * @description Monthly Restock状态
             * @example AVAILABLE
             */
            monthlyRestockStatus: string;
            /**
             * @description 是否有Monthly Restock奖励
             * @example true
             */
            hasMonthlyRestockReward: boolean;
            /**
             * Format: int64
             * @description 下次Weekly Edge发放时间戳
             * @example 1710854399000
             */
            nextWeeklyEdgeDistribution: number;
            /**
             * Format: int64
             * @description 下次Monthly Restock发放时间戳
             * @example 1710854399000
             */
            nextMonthlyRestockDistribution: number;
        };
        /** @description VIP权益响应 */
        VipBenefitResponse: {
            /**
             * Format: int64
             * @description 权益ID
             * @example 1
             */
            id: number;
            /**
             * @description 权益编码
             * @example BETBACK
             */
            code: string;
            /**
             * @description 权益标题
             * @example BetBack
             */
            title: string;
            /**
             * @description 权益描述
             * @example Instant cash rewards on every wager. Get 1% cashback on all your bets, credited instantly to your account.
             */
            description: string;
            /**
             * @description 权益图标URL
             * @example betback-icon.svg
             */
            iconUrl: string;
            /**
             * Format: int32
             * @description 排序
             * @example 1
             */
            sort: number;
            /**
             * @description 是否锁定 - 权益是否被锁定，通常因为VIP等级不足或解锁条件未满足
             * @example false
             */
            isLocked: boolean;
            /**
             * @description 是否可用 - 权益当前是否可用，考虑时间、次数、状态等综合因素
             * @example true
             */
            isAvailable: boolean;
            /**
             * Format: int32
             * @description 剩余使用次数
             * @example 5
             */
            remainTimes: number;
            /**
             * Format: int64
             * @description 过期时间戳
             * @example 1710940799000
             */
            expireTime: number;
            /**
             * @description 解锁等级
             * @example 2
             */
            unlockLevel: string;
            /**
             * Format: int64
             * @description 解锁所需积分
             * @example 2000
             */
            unlockPoints: number;
        };
        /** @description FAQ响应 */
        VipFaqResponse: {
            /**
             * Format: int64
             * @description FAQ ID
             * @example 1
             */
            id: number;
            /**
             * Format: int64
             * @description 分类ID
             * @example 1
             */
            categoryId: number;
            /**
             * @description 分类编码
             * @example GENERAL
             */
            categoryCode: string;
            /**
             * @description 分类名称
             * @example 通用问题
             */
            categoryName: string;
            /**
             * @description 问题
             * @example 如何成为VIP用户？
             */
            question: string;
            /**
             * @description 答案
             * @example 用户可以通过充值或完成任务来获得VIP等级...
             */
            answer: string;
            /**
             * Format: int32
             * @description 排序
             * @example 1
             */
            sort: number;
            /**
             * Format: int32
             * @description 状态：0=禁用，1=启用
             * @example 1
             */
            status: number;
            /**
             * @description 状态描述
             * @example 启用
             */
            statusDesc: string;
            /**
             * Format: int64
             * @description 创建时间（毫秒级时间戳）
             * @example 1765780577459
             */
            createdAt: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒级时间戳）
             * @example 1765780577459
             */
            updatedAt: number;
        };
        /** limit save */
        LimitSaveRequest: {
            /**
             * Limit type
             * @description wager、loss
             */
            limitType: string;
            /**
             * date type
             * @description day、week、monthly
             */
            dayType: string;
            /** limit amount */
            limitAmount: number;
            /** Currency Code */
            currencyCode: string;
        };
        SelfExclusionAddRequest: {
            /** day、week、permanent */
            type: string;
            /** reason */
            reason?: string;
        };
        SingleResponseSelfExclusionVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["SelfExclusionVO"];
        };
        SelfExclusionVO: {
            /** day、week、permanent */
            type: string;
            /** reason */
            reason: string;
            /**
             * Current System Time
             * Format: int64
             */
            currentTime: number;
            /**
             * Last update time
             * Format: int64
             */
            lastUpdateTime: number;
            /**
             * createTime
             * Format: int64
             */
            createTime: number;
            /**
             * end time
             * Format: int64
             */
            endTime: number;
        };
        SingleResponseQuestionResultVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["QuestionResultVO"];
        };
        /** Question Result */
        QuestionResultVO: {
            /**
             * score value
             * Format: int32
             */
            score: number;
            /**
             * Result type
             * @description low、high
             */
            type: string;
        };
        SingleResponseLimitAndSelfVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["LimitAndSelfVO"];
        };
        LimitAndSelfVO: {
            /** limit list */
            limitTypeVOS: components["schemas"]["LimitTypeVO"][];
            selfExclusionVO: components["schemas"]["SelfExclusionVO"];
        };
        /** limit info */
        LimitTypeVO: {
            /**
             * Limit type
             * @description wager、loss
             */
            limitType: string;
            /**
             * date type
             * @description day、week、monthly
             */
            dayType: string;
            /** Currency Code */
            currencyCode: string;
            /** limit amount */
            limitAmount: number;
            /** Progress Amount */
            progressAmount: number;
            /**
             * Current System Time
             * Format: int64
             */
            currentTime: number;
            /**
             * Last update time
             * Format: int64
             */
            lastUpdateTime: number;
            /**
             * createTime
             * Format: int64
             */
            createTime: number;
            /**
             * end time
             * Format: int64
             */
            endTime: number;
            /**
             * limit hour
             * Format: int32
             */
            limitHour: number;
        };
        SingleResponseListLimitTypeVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["LimitTypeVO"][];
        };
        /** save score */
        QuestionResultSaveRequest: {
            /**
             * score value
             * Format: int32
             */
            score: number;
            /**
             * Result type
             * @description low、high
             */
            type: string;
        };
        SingleResponseInsuranceVO: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["InsuranceVO"];
        };
        InsuranceVO: {
            /**
             * top up
             * @description true、false
             */
            topUp: boolean;
            /**
             * Place a bet
             * @description true、false
             */
            placeBet: boolean;
        };
        /** @description Captcha verification request */
        VerifyCaptchaRequest: {
            /**
             * @description Redis captcha key
             * @example verify:image:captcha:abc123
             */
            captchaKey: string;
            /**
             * Format: int32
             * @description score
             * @example 50
             */
            score?: number;
            /** Format: int32 */
            xcoordinate?: number;
        };
        SingleResponseVerifyCaptchaResult: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["VerifyCaptchaResult"];
        };
        /** @description Captcha verification result */
        VerifyCaptchaResult: {
            /**
             * @description Whether verification passed
             * @example true
             */
            success: boolean;
            /**
             * Format: int32
             * @description Score of the verification (0-10)
             * @example 8
             */
            score: number;
            /**
             * @description Reason message if verification failed
             * @example Verification failed: score too low
             */
            reason: string;
        };
        SingleResponseImageCaptchaResponse: {
            success: boolean;
            errCode: string;
            errMessage: string;
            data: components["schemas"]["ImageCaptchaResponse"];
        };
        /** @description Image captcha response */
        ImageCaptchaResponse: {
            /**
             * @description Base64 encoded background image with missing piece
             * @example data:image/svg+xml;base64,PHN2Zy...
             */
            backgroundImage: string;
            /**
             * @description Base64 encoded puzzle piece image
             * @example data:image/svg+xml;base64,PHN2Zy...
             */
            puzzlePiece: string;
            /**
             * @description Redis key for verification
             * @example verify:image:captcha:abc123
             */
            captchaKey: string;
            /**
             * Format: int32
             * @description Width of the puzzle piece
             * @example 50
             */
            pieceWidth: number;
            /**
             * Format: int32
             * @description Height of the puzzle piece
             * @example 50
             */
            pieceHeight: number;
            /** Format: int32 */
            ycoordinate: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    updateTemplate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTemplateUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    updateTask: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTaskUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    DictionaryChildUpdate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
                childCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryChildUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    DictionaryParentDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDictionaryParentResponse"];
                };
            };
        };
    };
    DictionaryParentUpdate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryParentUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    DictionaryParentDelete: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    addToWaitlist: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["WaitlistRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    verifyCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    sendVerificationCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendVerificationCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    recaptcha: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReCaptchaVerifierRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    recaptchaToken: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ReCaptchaVerifierRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    verifyCode_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    sendVerificationCode1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendVerificationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    sendVerificationCode_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SendVerificationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    uploadAvatar: {
        parameters: {
            query: {
                /** @description 文件 */
                "undefined": string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    updateUserInfo: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateProfileInfoRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createUserSettingUpdatePreference: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdatePreferenceRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    updatePassword: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdatePasswordRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createUserSettingUpdateContactInfo: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateContactInfoRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    pwdValidCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ContactCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    createUserSettingContactValidCode: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ContactCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    contactCheck: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ContactCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    checkPwdValidCode: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateContactInfoRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    checkOldPwd: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AuthenticateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    issueToken: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    verify2fa: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmSetupRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    AntiCrawlerInit: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                "X-Recaptcha-Token"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseAntiCrawlerInitResponse"];
                };
            };
        };
    };
    createUserRegisterWithVerification: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
                "X-Device-Id"?: string;
                "X-Pseudo-Id"?: string;
                "X-Channel-Type"?: number;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserRegisterWithVerificationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    resetPassword: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResetPasswordRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    verifyCodeAndGenerateToken: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyForgotPasswordRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    createPasswordForgotSendCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ForgotPasswordRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    setDefault: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyIdRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    rename: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyRenameRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    finishRegistration: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyRegistrationFinishRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    startRegistration: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyStartRegistrationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePasskeyRegistrationOptions"];
                };
            };
        };
    };
    finishOperationAuth: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyAuthenticationFinishRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    startOperationAuth: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePasskeyAuthenticationOptions"];
                };
            };
        };
    };
    delete: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyIdRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    finishAuthentication: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
                "X-Pseudo-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["PasskeyAuthenticationFinishRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLoginResult"];
                };
            };
        };
    };
    startAuthentication: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePasskeyAuthenticationOptions"];
                };
            };
        };
    };
    UserFollowMatchUnfollow: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFollowMatchRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    UserFollowMatchFollow: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFollowMatchRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    markRead: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": number[];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    markAllRead: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    UserMessageList: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserMessageListRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserPageResultUserMessage"];
                };
            };
        };
    };
    delete_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": number[];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    logout: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    login: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id"?: string;
                "X-Pseudo-Id"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLoginResult"];
                };
            };
        };
    };
    loginByCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
                "X-Device-Id"?: string;
                "X-Pseudo-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginByCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLoginResult"];
                };
            };
        };
    };
    createLoginCodeSend: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginCodeSendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    UserLoginCheckExists: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserExistCheckRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserExistCheckResponse"];
                };
            };
        };
    };
    login2faVerify: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
                "X-Device-Id"?: string;
                "X-Pseudo-Id"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["Login2faVerifyRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserLoginResult"];
                };
            };
        };
    };
    processBatchInviteCodes: {
        parameters: {
            query?: {
                batchSize?: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    InternalMessageSendText: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InternalTextMessageSendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    InternalMessageSendByTemplate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InternalTemplateMessageSendRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    InternalUserBatchBaseInfo: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserBatchQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListUserBaseInfoDTO"];
                };
            };
        };
    };
    rename_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserDeviceRenameRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    display: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerDisplayRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBannerResponse"];
                };
            };
        };
    };
    createUserBannersDisplayLogin: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerDisplayRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBannerResponse"];
                };
            };
        };
    };
    startSetup: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseTwoFactorAuthSetupResponse"];
                };
            };
        };
    };
    disable: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    confirmSetup: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmSetupRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    sendVerificationCodeEmail: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 验证码 */
                code: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendVerificationCodeEmailWithCustomSender: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 验证码 */
                code: string;
                /** @description 发件人邮箱（可选） */
                fromEmail?: string;
                /** @description 发件人名称（可选） */
                fromName?: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendTemplateEmail: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 模板ID */
                templateId: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendTemplateEmailWithCustomSender: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 模板ID */
                templateId: string;
                /** @description 发件人邮箱（可选） */
                fromEmail?: string;
                /** @description 发件人名称（可选） */
                fromName?: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendInviteCodeEmail: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 邀请码 */
                code: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendInviteCodeEmailWithCustomSender: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 邀请码 */
                code: string;
                /** @description 发件人邮箱（可选） */
                fromEmail?: string;
                /** @description 发件人名称（可选） */
                fromName?: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendTemplateEmail_1: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 模板ID */
                templateId: string;
                /** @description 业务场景代码 */
                sceneCode: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    sendTemplateEmailWithCustomSender_1: {
        parameters: {
            query: {
                /** @description 收件人邮箱 */
                email: string;
                /** @description 模板ID */
                templateId: string;
                /** @description 业务场景代码 */
                sceneCode: string;
                /** @description 自定义发件人邮箱（可选） */
                customFromEmail?: string;
                /** @description 自定义发件人名称（可选） */
                customFromName?: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    uploadAvatar_1: {
        parameters: {
            query: {
                /** @description 文件 */
                "undefined": string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": {
                    /** Format: binary */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseString"];
                };
            };
        };
    };
    listTemplates: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTemplateQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultMessageTemplateListResponse"];
                };
            };
        };
    };
    createTemplate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTemplateCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    AdminMessageTemplateCopy: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                templateId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    sendTask: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    sendNow: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    listRecipients: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTaskRecipientQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultMessageTaskRecipientListResponse"];
                };
            };
        };
    };
    listTasks: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTaskQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultMessageTaskListResponse"];
                };
            };
        };
    };
    AdminMessageTaskCreate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["MessageTaskCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    copyTask: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    cancelTask: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    testSend: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["NotificationRouteTestRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    BatchGenerateAndExportInviteCodes: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AdminBatchGenerateInviteCodeCmd"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    DictionaryChildCreate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryChildCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    DictionaryParentList: {
        parameters: {
            query: {
                request: components["schemas"]["DictionaryParentListRequest"];
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultDictionaryParentResponse"];
                };
            };
        };
    };
    DictionaryParentCreate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryParentCreateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    DictionaryChildI18nDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                childCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDictionaryI18nResponse"];
                };
            };
        };
    };
    DictionaryChildI18nSave: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                childCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryI18nSaveRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    updateBannerStatus: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerStatusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    saveBanner: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "multipart/form-data": components["schemas"]["BannerUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    pageQuery: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultBannerResponse"];
                };
            };
        };
    };
    pageHistory: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerHistoryQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultBannerHistoryResponse"];
                };
            };
        };
    };
    saveGroup: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerGroupUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    pageQuery_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerGroupQueryRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultBannerGroupResponse"];
                };
            };
        };
    };
    batchUpdateStatus: {
        parameters: {
            query: {
                /** @description 分组ID列表 */
                ids: number[];
                /** @description 目标状态（0-禁用，1-启用） */
                status: number;
                /** @description 操作人ID */
                operator: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    batchUpdateSort: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BannerSortRequest"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    DictionaryChildStatus: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
                childCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryChildStatusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    DictionaryParentStatus: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["DictionaryParentStatusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    list: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseCountryVpcMappingConfigDto"];
                };
            };
        };
    };
    profileInfo: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseProfileInfoResponse"];
                };
            };
        };
    };
    getUserSettingGetPreference: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePreferenceResponse"];
                };
            };
        };
    };
    getPreference_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePreferenceResponse"];
                };
            };
        };
    };
    disableWithdrawals: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    checkToken: {
        parameters: {
            query: {
                code: string;
            };
            header: {
                "X-Device-Id"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    isOld: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    InviteRequirementSwitchPublic: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteRequirementResponse"];
                };
            };
        };
    };
    checkWakeup: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id": string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePasskeyWakeupCheckResult"];
                };
            };
        };
    };
    list_1: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    UserFollowMatchList: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListTournamentAggMatchHitDto"];
                };
            };
        };
    };
    unreadCount: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInteger"];
                };
            };
        };
    };
    unreadByCategory: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListUnreadCountByCategoryResponse"];
                };
            };
        };
    };
    validateInviteCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                code: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getGenerationQuota: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteGenerationQuotaResponse"];
                };
            };
        };
    };
    generateInviteCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    health: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    GetUserDictionaryConfig: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description 父字典编码 */
                parentCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListDictionaryConfigResponse"];
                };
            };
        };
    };
    list_2: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["MultiResponseUserDeviceVO"];
                };
            };
        };
    };
    getCurrentUser: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserBasicResponse"];
                };
            };
        };
    };
    getAreaAll: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringObject"];
                };
            };
        };
    };
    ipIsIllegal: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    status: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseTwoFactorAuthEntity"];
                };
            };
        };
    };
    getSenderConfig: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description 业务场景代码 */
                sceneCode: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringString"];
                };
            };
        };
    };
    getAllScenes: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMapStringString"];
                };
            };
        };
    };
    modules: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
        };
    };
    languages: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
        };
    };
    categories: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
        };
    };
    getTemplateDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                templateId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMessageTemplateResponse"];
                };
            };
        };
    };
    AdminMessageTemplateCodes: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListString"];
                };
            };
        };
    };
    getTemplatesByCode: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                code: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMessageTemplateMultiLangResponse"];
                };
            };
        };
    };
    AdminMessageContentByRecipientId: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                recordId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMessageContentResponse"];
                };
            };
        };
    };
    getTaskDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseMessageTask"];
                };
            };
        };
    };
    DictionaryChildList: {
        parameters: {
            query: {
                request: components["schemas"]["DictionaryChildListRequest"];
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponsePageResultDictionaryChildResponse"];
                };
            };
        };
    };
    verifyRate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVerifySuccessRateResponse"];
                };
            };
        };
    };
    newVsChurn: {
        parameters: {
            query: {
                start: number;
                end: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseNewChurnTrendResponse"];
                };
            };
        };
    };
    statusDistribution: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseStatusDistributionResponse"];
                };
            };
        };
    };
    registerFunnel: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseRegisterFunnelResponse"];
                };
            };
        };
    };
    inviteChannelStats: {
        parameters: {
            query: {
                start: number;
                end: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteChannelStatsResponse"];
                };
            };
        };
    };
    channelQualityCompare: {
        parameters: {
            query: {
                start: number;
                end: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseChannelQualityCompareResponse"];
                };
            };
        };
    };
    channelEffect: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseChannelEffectResponse"];
                };
            };
        };
    };
    cards: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseDashboardCardsResponse"];
                };
            };
        };
    };
    activeHeatmap: {
        parameters: {
            query?: {
                mode?: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseActiveHeatmapResponse"];
                };
            };
        };
    };
    getBannerDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description BannerID */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBannerResponse"];
                };
            };
        };
    };
    deleteBanner: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description BannerID */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    listValidBanners: {
        parameters: {
            query: {
                /** @description 终端类型（pc/mobile/miniprogram） */
                terminal: string;
                /** @description 展示位置（如home_top） */
                position: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBannerResponse"];
                };
            };
        };
    };
    bannerListAllWithGroup: {
        parameters: {
            query?: {
                /** @description 分组ID，为空时返回所有Banner */
                groupId?: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBannerResponse"];
                };
            };
        };
    };
    getLatestHistory: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description Banner名称（支持模糊匹配的基础名称） */
                bannerName: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBannerHistoryResponse"];
                };
            };
        };
    };
    getGroupDetail: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description 分组ID */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBannerGroupResponse"];
                };
            };
        };
    };
    deleteGroup: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                /** @description 分组ID */
                id: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVoid"];
                };
            };
        };
    };
    bannerGroupListAll: {
        parameters: {
            query?: {
                /** @description 状态（0-禁用，1-启用，不传则查询全部） */
                status?: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListBannerGroupResponse"];
                };
            };
        };
    };
    deleteTemplate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                templateId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    removeDraftTask: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                taskId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseObject"];
                };
            };
        };
    };
    getUserIntercomGroup: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUserGroupResponse"];
                };
            };
        };
    };
    createInviteCodeCreate: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InviteCreateCodeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteCreateCodeResponse"];
                };
            };
        };
    };
    getUserInviteSummary: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteSummaryResponse"];
                };
            };
        };
    };
    getUserInviteDefault: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInviteDefaultCodeResponse"];
                };
            };
        };
    };
    getInviteCodeStats: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListInviteCodeStatsResponse"];
                };
            };
        };
    };
    getUserAffiliateRateRulesConfig: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseReferralRateRulesConfigDTO"];
                };
            };
        };
    };
    createUserTypeXGetOpenTicket: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TicketDTO"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    createUserTypeXAddTicket: {
        parameters: {
            query?: never;
            header: {
                "X-Device-Id"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TicketAddDTO"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    createUserTypeXActivelyDisconnects: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ActivelyDisconnectsDTO"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    getTypeX: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path: {
                type: number;
                userId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseData"];
                };
            };
        };
    };
    getInviteCodeList: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListInviteValidCodeResponse"];
                };
            };
        };
    };
    getUserSettingUsernameChangeCooldown: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseUsernameChangeCooldownResponse"];
                };
            };
        };
    };
    createVipUsersUpdatePreferredCurrency: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VipUserUpdateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    createVipRewardsClaim: {
        parameters: {
            query?: never;
            header: {
                "X-Request-Id"?: string;
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VipRewardClaimRequest"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListVipRewardResponse"];
                };
            };
        };
    };
    getVipUsersInfo: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVipUserResponse"];
                };
            };
        };
    };
    getVipRewardsList: {
        parameters: {
            query?: {
                status?: number;
                limit?: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListVipRewardResponse"];
                };
            };
        };
    };
    getRewardsActionDropDays: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVipActionDropDaysResponse"];
                };
            };
        };
    };
    getVipLevelsList: {
        parameters: {
            query?: {
                name?: string;
                points?: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListVipLevelResponse"];
                };
            };
        };
    };
    getUserVipHome: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVipHomeResponse"];
                };
            };
        };
    };
    getVipHomePreview: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVipHomeResponse"];
                };
            };
        };
    };
    getRewardsPendingCount: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLong"];
                };
            };
        };
    };
    createUserInsuranceSaveLimit: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LimitSaveRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    createUserInsuranceAddSelfExclusion: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SelfExclusionAddRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSelfExclusionVO"];
                };
            };
        };
    };
    getUserInsuranceRemoveLimit: {
        parameters: {
            query: {
                limitType: string;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    getUserInsuranceLastResult: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseQuestionResultVO"];
                };
            };
        };
    };
    getUserInsuranceGetSelfExclusion: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseSelfExclusionVO"];
                };
            };
        };
    };
    getUserInsuranceGetLimitAndSelfExclusion: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLimitAndSelfVO"];
                };
            };
        };
    };
    getUserInsuranceGetLimitAndSelfExclusionById: {
        parameters: {
            query: {
                userId: number;
            };
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseLimitAndSelfVO"];
                };
            };
        };
    };
    getUserInsuranceGetLimits: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseListLimitTypeVO"];
                };
            };
        };
    };
    createUserInsuranceSaveQuestionResult: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["QuestionResultSaveRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseBoolean"];
                };
            };
        };
    };
    getUserInsuranceGetInsuranceStatus: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseInsuranceVO"];
                };
            };
        };
    };
    createVerificationCaptchaVerify: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyCaptchaRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseVerifyCaptchaResult"];
                };
            };
        };
    };
    getUsersVerificationCaptcha: {
        parameters: {
            query?: never;
            header: {
                /** @description 客户端类型 */
                "X-Client-Type": string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["SingleResponseImageCaptchaResponse"];
                };
            };
        };
    };
}
export enum ApiPaths {
    updateTemplate = "/admin/user/message/template/update",
    updateTask = "/admin/user/message/task/update",
    DictionaryChildUpdate = "/admin/user/dictionaries/{parentCode}/children/{childCode}",
    DictionaryParentDetail = "/admin/user/dictionaries/parents/{parentCode}",
    DictionaryParentUpdate = "/admin/user/dictionaries/parents/{parentCode}",
    DictionaryParentDelete = "/admin/user/dictionaries/parents/{parentCode}",
    addToWaitlist = "/api/user/waitlist/add",
    verifyCode = "/api/user/verification/verify",
    sendVerificationCode = "/api/user/verification/send",
    recaptcha = "/api/user/verification/recaptcha",
    recaptchaToken = "/api/user/verification/recaptcha-token",
    verifyCode_1 = "/api/user/twilio/verify/verify",
    sendVerificationCode1 = "/api/user/twilio/verify/test",
    sendVerificationCode_1 = "/api/user/twilio/verify/send",
    uploadAvatar = "/api/user/system/file/upload/avatar",
    updateUserInfo = "/api/user/setting/updateProfileInfo",
    createUserSettingUpdatePreference = "/api/user/setting/updatePreference",
    updatePassword = "/api/user/setting/updatePassword",
    createUserSettingUpdateContactInfo = "/api/user/setting/updateContactInfo",
    pwdValidCode = "/api/user/setting/pwdValidCode",
    createUserSettingContactValidCode = "/api/user/setting/contactValidCode",
    contactCheck = "/api/user/setting/contactCheck",
    checkPwdValidCode = "/api/user/setting/checkPwdValidCode",
    checkOldPwd = "/api/user/setting/checkOldPwd",
    issueToken = "/api/user/security/verify/issue-token",
    verify2fa = "/api/user/security/verify/2fa",
    AntiCrawlerInit = "/api/user/security/anti-crawler/init",
    createUserRegisterWithVerification = "/api/user/register/with-verification",
    resetPassword = "/api/user/password/reset",
    verifyCodeAndGenerateToken = "/api/user/password/forgot/verify-code",
    createPasswordForgotSendCode = "/api/user/password/forgot/send-code",
    setDefault = "/api/user/passkey/set-default",
    rename = "/api/user/passkey/rename",
    finishRegistration = "/api/user/passkey/registration/result",
    startRegistration = "/api/user/passkey/registration/options",
    finishOperationAuth = "/api/user/passkey/operation-auth/result",
    startOperationAuth = "/api/user/passkey/operation-auth/options",
    delete = "/api/user/passkey/delete",
    finishAuthentication = "/api/user/passkey/authentication/result",
    startAuthentication = "/api/user/passkey/authentication/options",
    UserFollowMatchUnfollow = "/api/user/my/followMatches/unfollow",
    UserFollowMatchFollow = "/api/user/my/followMatches/follow",
    markRead = "/api/user/message/read",
    markAllRead = "/api/user/message/readAll",
    UserMessageList = "/api/user/message/list",
    delete_1 = "/api/user/message/delete",
    logout = "/api/user/logout",
    login = "/api/user/login",
    loginByCode = "/api/user/login/code/verify",
    createLoginCodeSend = "/api/user/login/code/send",
    UserLoginCheckExists = "/api/user/login/check-exists",
    login2faVerify = "/api/user/login/2fa/verify",
    processBatchInviteCodes = "/api/user/invite/process/batch",
    InternalMessageSendText = "/api/user/internal/message/send-text",
    InternalMessageSendByTemplate = "/api/user/internal/message/send-by-template",
    InternalUserBatchBaseInfo = "/api/user/internal/info/batch/base-info",
    rename_1 = "/api/user/device/rename",
    display = "/api/user/banners/display",
    createUserBannersDisplayLogin = "/api/user/banners/display-login",
    startSetup = "/api/user/2fa/start-setup",
    disable = "/api/user/2fa/disable",
    confirmSetup = "/api/user/2fa/confirm-setup",
    sendVerificationCodeEmail = "/api/email/sendgrid/verification",
    sendVerificationCodeEmailWithCustomSender = "/api/email/sendgrid/verification/custom-sender",
    sendTemplateEmail = "/api/email/sendgrid/template",
    sendTemplateEmailWithCustomSender = "/api/email/sendgrid/template/custom-sender",
    sendInviteCodeEmail = "/api/email/sendgrid/invite",
    sendInviteCodeEmailWithCustomSender = "/api/email/sendgrid/invite/custom-sender",
    sendTemplateEmail_1 = "/api/email/scene/template",
    sendTemplateEmailWithCustomSender_1 = "/api/email/scene/template/custom-sender",
    uploadAvatar_1 = "/admin/user/system/file/upload/avatar",
    listTemplates = "/admin/user/message/template/list",
    createTemplate = "/admin/user/message/template/create",
    AdminMessageTemplateCopy = "/admin/user/message/template/copy/{templateId}",
    sendTask = "/admin/user/message/task/send/{taskId}",
    sendNow = "/admin/user/message/task/send-now/{taskId}",
    listRecipients = "/admin/user/message/task/recipients",
    listTasks = "/admin/user/message/task/list",
    AdminMessageTaskCreate = "/admin/user/message/task/create",
    copyTask = "/admin/user/message/task/copy/{taskId}",
    cancelTask = "/admin/user/message/task/cancel/{taskId}",
    testSend = "/admin/user/message/route/test-send",
    BatchGenerateAndExportInviteCodes = "/admin/user/invite/batch-export",
    DictionaryChildCreate = "/admin/user/dictionaries/{parentCode}/children",
    DictionaryParentList = "/admin/user/dictionaries/parents",
    DictionaryParentCreate = "/admin/user/dictionaries/parents",
    DictionaryChildI18nDetail = "/admin/user/dictionaries/children/{childCode}/i18n",
    DictionaryChildI18nSave = "/admin/user/dictionaries/children/{childCode}/i18n",
    updateBannerStatus = "/admin/user/banners/update-status",
    saveBanner = "/admin/user/banners/save",
    pageQuery = "/admin/user/banners/page",
    pageHistory = "/admin/user/banners/history/page",
    saveGroup = "/admin/user/banners/group/save",
    pageQuery_1 = "/admin/user/banners/group/page",
    batchUpdateStatus = "/admin/user/banners/group/batch-update-status",
    batchUpdateSort = "/admin/user/banners/batch-update-sort",
    DictionaryChildStatus = "/admin/user/dictionaries/{parentCode}/children/{childCode}/status",
    DictionaryParentStatus = "/admin/user/dictionaries/parents/{parentCode}/status",
    list = "/api/user/system/cid/list",
    profileInfo = "/api/user/setting/profileInfo",
    getUserSettingGetPreference = "/api/user/setting/getPreference",
    getPreference_1 = "/api/user/setting/getPreference/{userId}",
    disableWithdrawals = "/api/user/setting/disableWithdrawals/{userId}",
    checkToken = "/api/user/security/verify/check-token",
    isOld = "/api/user/security/device/is-old",
    InviteRequirementSwitchPublic = "/api/user/public/invite/config/requirement",
    checkWakeup = "/api/user/passkey/wakeup/check",
    list_1 = "/api/user/passkey/list",
    UserFollowMatchList = "/api/user/my/followMatches/list",
    unreadCount = "/api/user/message/unread/count",
    unreadByCategory = "/api/user/message/unread/by-category",
    validateInviteCode = "/api/user/invite/validate/{code}",
    getGenerationQuota = "/api/user/invite/quota",
    generateInviteCode = "/api/user/invite/generate",
    health = "/api/user/health",
    GetUserDictionaryConfig = "/api/user/dictionary/config/{parentCode}",
    list_2 = "/api/user/device/list",
    getCurrentUser = "/api/user/basic",
    getAreaAll = "/api/user/area/list",
    ipIsIllegal = "/api/user/area/ipIsIllegal",
    status = "/api/user/2fa/status/{userId}",
    getSenderConfig = "/api/email/scene/sender-config/{sceneCode}",
    getAllScenes = "/api/email/scene/scenes",
    modules = "/admin/user/message/template/meta/modules",
    languages = "/admin/user/message/template/meta/languages",
    categories = "/admin/user/message/template/meta/categories",
    getTemplateDetail = "/admin/user/message/template/detail/{templateId}",
    AdminMessageTemplateCodes = "/admin/user/message/template/codes",
    getTemplatesByCode = "/admin/user/message/template/by-code/{code}",
    AdminMessageContentByRecipientId = "/admin/user/message/task/message/{recordId}",
    getTaskDetail = "/admin/user/message/task/detail/{taskId}",
    DictionaryChildList = "/admin/user/dictionaries/children",
    verifyRate = "/admin/user/dashboard/verify/rate",
    newVsChurn = "/admin/user/dashboard/trend/new-vs-churn",
    statusDistribution = "/admin/user/dashboard/status/distribution",
    registerFunnel = "/admin/user/dashboard/register/funnel",
    inviteChannelStats = "/admin/user/dashboard/invite/channel-stats",
    channelQualityCompare = "/admin/user/dashboard/channel/quality-compare",
    channelEffect = "/admin/user/dashboard/channel/effect",
    cards = "/admin/user/dashboard/cards",
    activeHeatmap = "/admin/user/dashboard/active/heatmap",
    getBannerDetail = "/admin/user/banners/{id}",
    deleteBanner = "/admin/user/banners/{id}",
    listValidBanners = "/admin/user/banners/valid",
    bannerListAllWithGroup = "/admin/user/banners/list",
    getLatestHistory = "/admin/user/banners/history/latest/{bannerName}",
    getGroupDetail = "/admin/user/banners/group/{id}",
    deleteGroup = "/admin/user/banners/group/{id}",
    bannerGroupListAll = "/admin/user/banners/group/list",
    deleteTemplate = "/admin/user/message/template/delete/{templateId}",
    removeDraftTask = "/admin/user/message/task/remove/{taskId}",
    getUserIntercomGroup = "/api/user/intercom/group",
    createInviteCodeCreate = "/api/user/invite/code/create",
    getUserInviteSummary = "/api/user/invite/summary",
    getUserInviteDefault = "/api/user/invite/default",
    getInviteCodeStats = "/api/user/invite/code/stats",
    getUserAffiliateRateRulesConfig = "/api/user/affiliate/rate-rules-config",
    createUserTypeXGetOpenTicket = "/api/user/typeX/getOpenTicket",
    createUserTypeXAddTicket = "/api/user/typeX/addTicket",
    createUserTypeXActivelyDisconnects = "/api/user/typeX/activelyDisconnects",
    getTypeX = "/api/user/typeX/{type}/{userId}",
    getInviteCodeList = "/api/user/invite/code/list",
    getUserSettingUsernameChangeCooldown = "/api/user/setting/usernameChangeCooldown",
    createVipUsersUpdatePreferredCurrency = "/api/user/vip/users/update-preferred-currency",
    createVipRewardsClaim = "/api/user/vip/rewards/claim",
    getVipUsersInfo = "/api/user/vip/users/info",
    getVipRewardsList = "/api/user/vip/rewards/list",
    getRewardsActionDropDays = "/api/user/vip/rewards/action-drop/days",
    getVipLevelsList = "/api/user/vip/levels/list",
    getUserVipHome = "/api/user/vip/home",
    getVipHomePreview = "/api/user/vip/home/preview",
    getRewardsPendingCount = "/api/user/vip/rewards/pending/count",
    createUserInsuranceSaveLimit = "/api/user/insurance/saveLimit",
    createUserInsuranceAddSelfExclusion = "/api/user/insurance/addSelfExclusion",
    getUserInsuranceRemoveLimit = "/api/user/insurance/removeLimit",
    getUserInsuranceLastResult = "/api/user/insurance/lastResult",
    getUserInsuranceGetSelfExclusion = "/api/user/insurance/getSelfExclusion",
    getUserInsuranceGetLimitAndSelfExclusion = "/api/user/insurance/getLimitAndSelfExclusion",
    getUserInsuranceGetLimitAndSelfExclusionById = "/api/user/insurance/getLimitAndSelfExclusionById",
    getUserInsuranceGetLimits = "/api/user/insurance/getLimits",
    createUserInsuranceSaveQuestionResult = "/api/user/insurance/saveQuestionResult",
    getUserInsuranceGetInsuranceStatus = "/api/user/insurance/getInsuranceStatus",
    createVerificationCaptchaVerify = "/api/user/users/verification/captcha/verify",
    getUsersVerificationCaptcha = "/api/user/users/verification/captcha"
}
